/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface MetricsObservabilityService {
  /** @summary List Definitions */
  listDefinitionsAdminObservabilityDefinitionsGet: {
    /** @summary List Definitions */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters,
            TMeta,
            TSignal
          >
        | (QueryFnOptionsByParameters<
            ListDefinitionsAdminObservabilityDefinitionsGetParameters,
            TMeta,
            TSignal
          > | void),
      client?: (
        schema: ListDefinitionsAdminObservabilityDefinitionsGetSchema,
        options: {
          parameters: ListDefinitionsAdminObservabilityDefinitionsGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          ListDefinitionsAdminObservabilityDefinitionsGetData,
          ListDefinitionsAdminObservabilityDefinitionsGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        ListDefinitionsAdminObservabilityDefinitionsGetData,
        ListDefinitionsAdminObservabilityDefinitionsGetError
      >
    >;
    /** @summary List Definitions */
    getQueryKey(
      parameters: DeepReadonly<ListDefinitionsAdminObservabilityDefinitionsGetParameters> | void
    ): ServiceOperationQueryKey<
      ListDefinitionsAdminObservabilityDefinitionsGetSchema,
      ListDefinitionsAdminObservabilityDefinitionsGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Definitions
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.metricsObservabilityService.listDefinitionsAdminObservabilityDefinitionsGet.useQuery()
     * ```
     */
    useQuery<TData = ListDefinitionsAdminObservabilityDefinitionsGetData>(
      parameters:
        | ServiceOperationQueryKey<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters
          >
        | (DeepReadonly<ListDefinitionsAdminObservabilityDefinitionsGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          ListDefinitionsAdminObservabilityDefinitionsGetData,
          ListDefinitionsAdminObservabilityDefinitionsGetError,
          TData,
          ServiceOperationQueryKey<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<ListDefinitionsAdminObservabilityDefinitionsGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Definitions
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.metricsObservabilityService.listDefinitionsAdminObservabilityDefinitionsGet.useQuery()
     * ```
     */
    useQuery<TData = ListDefinitionsAdminObservabilityDefinitionsGetData>(
      parameters:
        | ServiceOperationQueryKey<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters
          >
        | (DeepReadonly<ListDefinitionsAdminObservabilityDefinitionsGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          ListDefinitionsAdminObservabilityDefinitionsGetData,
          ListDefinitionsAdminObservabilityDefinitionsGetError,
          TData,
          ServiceOperationQueryKey<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<ListDefinitionsAdminObservabilityDefinitionsGetError>>;
    /** @summary List Definitions */
    getInfiniteQueryKey(
      parameters: DeepReadonly<ListDefinitionsAdminObservabilityDefinitionsGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<
      ListDefinitionsAdminObservabilityDefinitionsGetSchema,
      ListDefinitionsAdminObservabilityDefinitionsGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Definitions
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.metricsObservabilityService.listDefinitionsAdminObservabilityDefinitionsGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListDefinitionsAdminObservabilityDefinitionsGetParameters,
      TQueryFnData = ListDefinitionsAdminObservabilityDefinitionsGetData,
      TData = OperationInfiniteData<TQueryFnData, ListDefinitionsAdminObservabilityDefinitionsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters
          >
        | (DeepReadonly<ListDefinitionsAdminObservabilityDefinitionsGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListDefinitionsAdminObservabilityDefinitionsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<ListDefinitionsAdminObservabilityDefinitionsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Definitions
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.metricsObservabilityService.listDefinitionsAdminObservabilityDefinitionsGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListDefinitionsAdminObservabilityDefinitionsGetParameters,
      TQueryFnData = ListDefinitionsAdminObservabilityDefinitionsGetData,
      TData = OperationInfiniteData<TQueryFnData, ListDefinitionsAdminObservabilityDefinitionsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters
          >
        | (DeepReadonly<ListDefinitionsAdminObservabilityDefinitionsGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListDefinitionsAdminObservabilityDefinitionsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          ListDefinitionsAdminObservabilityDefinitionsGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<ListDefinitionsAdminObservabilityDefinitionsGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary List Definitions
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const listDefinitionsAdminObservabilityDefinitionsGetTotal = qraft.metricsObservabilityService.listDefinitionsAdminObservabilityDefinitionsGet.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetData,
            TInfinite,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters,
            ListDefinitionsAdminObservabilityDefinitionsGetError
          >
        | QueryFiltersByQueryKey<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetData,
            TInfinite,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters,
            ListDefinitionsAdminObservabilityDefinitionsGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary List Definitions
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const listDefinitionsAdminObservabilityDefinitionsGetResults = qraft.metricsObservabilityService.listDefinitionsAdminObservabilityDefinitionsGet.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listDefinitionsAdminObservabilityDefinitionsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const listDefinitionsAdminObservabilityDefinitionsGetCombinedResults = qraft.metricsObservabilityService.listDefinitionsAdminObservabilityDefinitionsGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listDefinitionsAdminObservabilityDefinitionsGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          ListDefinitionsAdminObservabilityDefinitionsGetSchema,
          ListDefinitionsAdminObservabilityDefinitionsGetParameters,
          ListDefinitionsAdminObservabilityDefinitionsGetData,
          ListDefinitionsAdminObservabilityDefinitionsGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          ListDefinitionsAdminObservabilityDefinitionsGetData,
          ListDefinitionsAdminObservabilityDefinitionsGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            ListDefinitionsAdminObservabilityDefinitionsGetData,
            ListDefinitionsAdminObservabilityDefinitionsGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary List Definitions
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.metricsObservabilityService.listDefinitionsAdminObservabilityDefinitionsGet.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = ListDefinitionsAdminObservabilityDefinitionsGetData>(
      parameters:
        | ServiceOperationQueryKey<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters
          >
        | (DeepReadonly<ListDefinitionsAdminObservabilityDefinitionsGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          ListDefinitionsAdminObservabilityDefinitionsGetData,
          ListDefinitionsAdminObservabilityDefinitionsGetError,
          TData,
          ServiceOperationQueryKey<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<ListDefinitionsAdminObservabilityDefinitionsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary List Definitions
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.metricsObservabilityService.listDefinitionsAdminObservabilityDefinitionsGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends ListDefinitionsAdminObservabilityDefinitionsGetParameters,
      TData = ListDefinitionsAdminObservabilityDefinitionsGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters
          >
        | (DeepReadonly<ListDefinitionsAdminObservabilityDefinitionsGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          ListDefinitionsAdminObservabilityDefinitionsGetData,
          ListDefinitionsAdminObservabilityDefinitionsGetError,
          OperationInfiniteData<TData, ListDefinitionsAdminObservabilityDefinitionsGetParameters>,
          ServiceOperationInfiniteQueryKey<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          ListDefinitionsAdminObservabilityDefinitionsGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, ListDefinitionsAdminObservabilityDefinitionsGetParameters>,
      OperationError<ListDefinitionsAdminObservabilityDefinitionsGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary List Definitions
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const listDefinitionsAdminObservabilityDefinitionsGetData = qraft.metricsObservabilityService.listDefinitionsAdminObservabilityDefinitionsGet.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listDefinitionsAdminObservabilityDefinitionsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const listDefinitionsAdminObservabilityDefinitionsGetCombinedData = qraft.metricsObservabilityService.listDefinitionsAdminObservabilityDefinitionsGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listDefinitionsAdminObservabilityDefinitionsGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          ListDefinitionsAdminObservabilityDefinitionsGetSchema,
          ListDefinitionsAdminObservabilityDefinitionsGetParameters,
          ListDefinitionsAdminObservabilityDefinitionsGetData,
          ListDefinitionsAdminObservabilityDefinitionsGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          ListDefinitionsAdminObservabilityDefinitionsGetData,
          ListDefinitionsAdminObservabilityDefinitionsGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              ListDefinitionsAdminObservabilityDefinitionsGetData,
              ListDefinitionsAdminObservabilityDefinitionsGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary List Definitions */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListDefinitionsAdminObservabilityDefinitionsGetSchema,
        ListDefinitionsAdminObservabilityDefinitionsGetData,
        ListDefinitionsAdminObservabilityDefinitionsGetParameters,
        ListDefinitionsAdminObservabilityDefinitionsGetError
      > | void
    ): Promise<ListDefinitionsAdminObservabilityDefinitionsGetData>;
    /** @summary List Definitions */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListDefinitionsAdminObservabilityDefinitionsGetSchema,
        ListDefinitionsAdminObservabilityDefinitionsGetData,
        ListDefinitionsAdminObservabilityDefinitionsGetParameters,
        ListDefinitionsAdminObservabilityDefinitionsGetError
      > | void
    ): Promise<void>;
    /** @summary List Definitions */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        ListDefinitionsAdminObservabilityDefinitionsGetSchema,
        ListDefinitionsAdminObservabilityDefinitionsGetData,
        ListDefinitionsAdminObservabilityDefinitionsGetParameters,
        ListDefinitionsAdminObservabilityDefinitionsGetError
      > | void
    ): Promise<ListDefinitionsAdminObservabilityDefinitionsGetData>;
    /** @summary List Definitions */
    fetchInfiniteQuery<TPageParam extends ListDefinitionsAdminObservabilityDefinitionsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListDefinitionsAdminObservabilityDefinitionsGetSchema,
        ListDefinitionsAdminObservabilityDefinitionsGetData,
        ListDefinitionsAdminObservabilityDefinitionsGetParameters,
        DeepReadonly<TPageParam>,
        ListDefinitionsAdminObservabilityDefinitionsGetError
      > | void
    ): Promise<
      OperationInfiniteData<
        ListDefinitionsAdminObservabilityDefinitionsGetData,
        ListDefinitionsAdminObservabilityDefinitionsGetParameters
      >
    >;
    /** @summary List Definitions */
    prefetchInfiniteQuery<TPageParam extends ListDefinitionsAdminObservabilityDefinitionsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListDefinitionsAdminObservabilityDefinitionsGetSchema,
        ListDefinitionsAdminObservabilityDefinitionsGetData,
        ListDefinitionsAdminObservabilityDefinitionsGetParameters,
        DeepReadonly<TPageParam>,
        ListDefinitionsAdminObservabilityDefinitionsGetError
      > | void
    ): Promise<void>;
    /** @summary List Definitions */
    ensureInfiniteQueryData<TPageParam extends ListDefinitionsAdminObservabilityDefinitionsGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        ListDefinitionsAdminObservabilityDefinitionsGetSchema,
        ListDefinitionsAdminObservabilityDefinitionsGetData,
        ListDefinitionsAdminObservabilityDefinitionsGetParameters,
        DeepReadonly<TPageParam>,
        ListDefinitionsAdminObservabilityDefinitionsGetError
      > | void
    ): Promise<
      OperationInfiniteData<
        ListDefinitionsAdminObservabilityDefinitionsGetData,
        ListDefinitionsAdminObservabilityDefinitionsGetParameters
      >
    >;
    /** @summary List Definitions */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters
          >
        | (DeepReadonly<ListDefinitionsAdminObservabilityDefinitionsGetParameters> | void)
    ): ListDefinitionsAdminObservabilityDefinitionsGetData | undefined;
    /** @summary List Definitions */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters
          >
        | (DeepReadonly<ListDefinitionsAdminObservabilityDefinitionsGetParameters> | void)
    ):
      | OperationInfiniteData<
          ListDefinitionsAdminObservabilityDefinitionsGetData,
          ListDefinitionsAdminObservabilityDefinitionsGetParameters
        >
      | undefined;
    /** @summary List Definitions */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetData,
            TInfinite,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters,
            ListDefinitionsAdminObservabilityDefinitionsGetError
          >
        | QueryFiltersByQueryKey<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetData,
            TInfinite,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters,
            ListDefinitionsAdminObservabilityDefinitionsGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              ListDefinitionsAdminObservabilityDefinitionsGetSchema,
              ListDefinitionsAdminObservabilityDefinitionsGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    ListDefinitionsAdminObservabilityDefinitionsGetData,
                    ListDefinitionsAdminObservabilityDefinitionsGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              ListDefinitionsAdminObservabilityDefinitionsGetSchema,
              ListDefinitionsAdminObservabilityDefinitionsGetParameters
            >,
            data: ListDefinitionsAdminObservabilityDefinitionsGetData | undefined,
          ]
        >;
    /** @summary List Definitions */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters
          >
        | (DeepReadonly<ListDefinitionsAdminObservabilityDefinitionsGetParameters> | void)
    ):
      | QueryState<
          ListDefinitionsAdminObservabilityDefinitionsGetData,
          ListDefinitionsAdminObservabilityDefinitionsGetError
        >
      | undefined;
    /** @summary List Definitions */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<ListDefinitionsAdminObservabilityDefinitionsGetParameters>
        | ServiceOperationInfiniteQueryKey<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters
          >
        | void
    ):
      | QueryState<
          OperationInfiniteData<
            ListDefinitionsAdminObservabilityDefinitionsGetData,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters
          >,
          ListDefinitionsAdminObservabilityDefinitionsGetError
        >
      | undefined;
    /** @summary List Definitions */
    setQueryData(
      parameters:
        | (DeepReadonly<ListDefinitionsAdminObservabilityDefinitionsGetParameters> | undefined)
        | ServiceOperationQueryKey<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters
          >,
      updater: Updater<
        NoInfer<ListDefinitionsAdminObservabilityDefinitionsGetData> | undefined,
        NoInfer<DeepReadonly<ListDefinitionsAdminObservabilityDefinitionsGetData>> | undefined
      >,
      options?: SetDataOptions
    ): ListDefinitionsAdminObservabilityDefinitionsGetData | undefined;
    /** @summary List Definitions */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<ListDefinitionsAdminObservabilityDefinitionsGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              ListDefinitionsAdminObservabilityDefinitionsGetData,
              ListDefinitionsAdminObservabilityDefinitionsGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                ListDefinitionsAdminObservabilityDefinitionsGetData,
                ListDefinitionsAdminObservabilityDefinitionsGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          ListDefinitionsAdminObservabilityDefinitionsGetData,
          ListDefinitionsAdminObservabilityDefinitionsGetParameters
        >
      | undefined;
    /** @summary List Definitions */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetData,
            TInfinite,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters,
            ListDefinitionsAdminObservabilityDefinitionsGetError
          >
        | QueryFiltersByQueryKey<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetData,
            TInfinite,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters,
            ListDefinitionsAdminObservabilityDefinitionsGetError
          >,
      updater: Updater<
        NoInfer<ListDefinitionsAdminObservabilityDefinitionsGetData> | undefined,
        NoInfer<ListDefinitionsAdminObservabilityDefinitionsGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<ListDefinitionsAdminObservabilityDefinitionsGetData | undefined>;
    /** @summary List Definitions */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        ListDefinitionsAdminObservabilityDefinitionsGetSchema,
        ListDefinitionsAdminObservabilityDefinitionsGetData,
        TInfinite,
        ListDefinitionsAdminObservabilityDefinitionsGetParameters,
        ListDefinitionsAdminObservabilityDefinitionsGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary List Definitions */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetData,
            TInfinite,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters,
            ListDefinitionsAdminObservabilityDefinitionsGetError
          >
        | QueryFiltersByQueryKey<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetData,
            TInfinite,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters,
            ListDefinitionsAdminObservabilityDefinitionsGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary List Definitions */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetData,
            TInfinite,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters,
            ListDefinitionsAdminObservabilityDefinitionsGetError
          >
        | QueryFiltersByQueryKey<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetData,
            TInfinite,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters,
            ListDefinitionsAdminObservabilityDefinitionsGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary List Definitions */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetData,
            TInfinite,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters,
            ListDefinitionsAdminObservabilityDefinitionsGetError
          >
        | QueryFiltersByQueryKey<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetData,
            TInfinite,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters,
            ListDefinitionsAdminObservabilityDefinitionsGetError
          >
    ): void;
    /** @summary List Definitions */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetData,
            TInfinite,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters,
            ListDefinitionsAdminObservabilityDefinitionsGetError
          >
        | QueryFiltersByQueryKey<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetData,
            TInfinite,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters,
            ListDefinitionsAdminObservabilityDefinitionsGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary List Definitions */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetData,
            TInfinite,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters,
            ListDefinitionsAdminObservabilityDefinitionsGetError
          >
        | QueryFiltersByQueryKey<
            ListDefinitionsAdminObservabilityDefinitionsGetSchema,
            ListDefinitionsAdminObservabilityDefinitionsGetData,
            TInfinite,
            ListDefinitionsAdminObservabilityDefinitionsGetParameters,
            ListDefinitionsAdminObservabilityDefinitionsGetError
          >
    ): number;
    schema: ListDefinitionsAdminObservabilityDefinitionsGetSchema;
    types: {
      parameters: ListDefinitionsAdminObservabilityDefinitionsGetParameters;
      data: ListDefinitionsAdminObservabilityDefinitionsGetData;
      error: ListDefinitionsAdminObservabilityDefinitionsGetError;
    };
  };
  /** @summary Create Definition */
  createDefinitionAdminObservabilityConfigDefinitionsPost: {
    /** @summary Create Definition */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CreateDefinitionAdminObservabilityConfigDefinitionsPostBody,
        CreateDefinitionAdminObservabilityConfigDefinitionsPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CreateDefinitionAdminObservabilityConfigDefinitionsPostSchema,
        options: ServiceOperationMutationFnOptions<
          CreateDefinitionAdminObservabilityConfigDefinitionsPostBody,
          CreateDefinitionAdminObservabilityConfigDefinitionsPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          CreateDefinitionAdminObservabilityConfigDefinitionsPostData,
          CreateDefinitionAdminObservabilityConfigDefinitionsPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        CreateDefinitionAdminObservabilityConfigDefinitionsPostData,
        CreateDefinitionAdminObservabilityConfigDefinitionsPostError
      >
    >;
    /** @summary Create Definition */
    getMutationKey(
      parameters: DeepReadonly<CreateDefinitionAdminObservabilityConfigDefinitionsPostParameters> | void
    ): ServiceOperationMutationKey<
      CreateDefinitionAdminObservabilityConfigDefinitionsPostSchema,
      CreateDefinitionAdminObservabilityConfigDefinitionsPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Definition
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.metricsObservabilityService.createDefinitionAdminObservabilityConfigDefinitionsPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.metricsObservabilityService.createDefinitionAdminObservabilityConfigDefinitionsPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateDefinitionAdminObservabilityConfigDefinitionsPostBody, TContext = unknown>(
      parameters: DeepReadonly<CreateDefinitionAdminObservabilityConfigDefinitionsPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateDefinitionAdminObservabilityConfigDefinitionsPostSchema,
        CreateDefinitionAdminObservabilityConfigDefinitionsPostData,
        CreateDefinitionAdminObservabilityConfigDefinitionsPostParameters,
        TVariables,
        OperationError<CreateDefinitionAdminObservabilityConfigDefinitionsPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateDefinitionAdminObservabilityConfigDefinitionsPostData,
      OperationError<CreateDefinitionAdminObservabilityConfigDefinitionsPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Definition
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.metricsObservabilityService.createDefinitionAdminObservabilityConfigDefinitionsPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.metricsObservabilityService.createDefinitionAdminObservabilityConfigDefinitionsPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        CreateDefinitionAdminObservabilityConfigDefinitionsPostBody,
        CreateDefinitionAdminObservabilityConfigDefinitionsPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateDefinitionAdminObservabilityConfigDefinitionsPostSchema,
        CreateDefinitionAdminObservabilityConfigDefinitionsPostData,
        CreateDefinitionAdminObservabilityConfigDefinitionsPostParameters,
        TVariables,
        OperationError<CreateDefinitionAdminObservabilityConfigDefinitionsPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateDefinitionAdminObservabilityConfigDefinitionsPostData,
      OperationError<CreateDefinitionAdminObservabilityConfigDefinitionsPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create Definition
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createDefinitionAdminObservabilityConfigDefinitionsPostTotal = qraft.metricsObservabilityService.createDefinitionAdminObservabilityConfigDefinitionsPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createDefinitionAdminObservabilityConfigDefinitionsPostTotal = qraft.metricsObservabilityService.createDefinitionAdminObservabilityConfigDefinitionsPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateDefinitionAdminObservabilityConfigDefinitionsPostBody,
            CreateDefinitionAdminObservabilityConfigDefinitionsPostData,
            CreateDefinitionAdminObservabilityConfigDefinitionsPostParameters,
            OperationError<CreateDefinitionAdminObservabilityConfigDefinitionsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateDefinitionAdminObservabilityConfigDefinitionsPostSchema,
            CreateDefinitionAdminObservabilityConfigDefinitionsPostBody,
            CreateDefinitionAdminObservabilityConfigDefinitionsPostData,
            CreateDefinitionAdminObservabilityConfigDefinitionsPostParameters,
            OperationError<CreateDefinitionAdminObservabilityConfigDefinitionsPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create Definition
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createDefinitionAdminObservabilityConfigDefinitionsPostPendingMutationVariables = qraft.metricsObservabilityService.createDefinitionAdminObservabilityConfigDefinitionsPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createDefinitionAdminObservabilityConfigDefinitionsPostMutationData = qraft.metricsObservabilityService.createDefinitionAdminObservabilityConfigDefinitionsPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateDefinitionAdminObservabilityConfigDefinitionsPostData,
        OperationError<CreateDefinitionAdminObservabilityConfigDefinitionsPostError>,
        MutationVariables<
          CreateDefinitionAdminObservabilityConfigDefinitionsPostBody,
          CreateDefinitionAdminObservabilityConfigDefinitionsPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateDefinitionAdminObservabilityConfigDefinitionsPostBody,
            CreateDefinitionAdminObservabilityConfigDefinitionsPostData,
            CreateDefinitionAdminObservabilityConfigDefinitionsPostParameters,
            OperationError<CreateDefinitionAdminObservabilityConfigDefinitionsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateDefinitionAdminObservabilityConfigDefinitionsPostSchema,
            CreateDefinitionAdminObservabilityConfigDefinitionsPostBody,
            CreateDefinitionAdminObservabilityConfigDefinitionsPostData,
            CreateDefinitionAdminObservabilityConfigDefinitionsPostParameters,
            OperationError<CreateDefinitionAdminObservabilityConfigDefinitionsPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateDefinitionAdminObservabilityConfigDefinitionsPostData,
          OperationError<CreateDefinitionAdminObservabilityConfigDefinitionsPostError>,
          MutationVariables<
            CreateDefinitionAdminObservabilityConfigDefinitionsPostBody,
            CreateDefinitionAdminObservabilityConfigDefinitionsPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Create Definition */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateDefinitionAdminObservabilityConfigDefinitionsPostBody,
            CreateDefinitionAdminObservabilityConfigDefinitionsPostData,
            CreateDefinitionAdminObservabilityConfigDefinitionsPostParameters,
            OperationError<CreateDefinitionAdminObservabilityConfigDefinitionsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateDefinitionAdminObservabilityConfigDefinitionsPostSchema,
            CreateDefinitionAdminObservabilityConfigDefinitionsPostBody,
            CreateDefinitionAdminObservabilityConfigDefinitionsPostData,
            CreateDefinitionAdminObservabilityConfigDefinitionsPostParameters,
            OperationError<CreateDefinitionAdminObservabilityConfigDefinitionsPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create Definition
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.metricsObservabilityService.createDefinitionAdminObservabilityConfigDefinitionsPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.metricsObservabilityService.createDefinitionAdminObservabilityConfigDefinitionsPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateDefinitionAdminObservabilityConfigDefinitionsPostBody,
              CreateDefinitionAdminObservabilityConfigDefinitionsPostData,
              CreateDefinitionAdminObservabilityConfigDefinitionsPostParameters,
              OperationError<CreateDefinitionAdminObservabilityConfigDefinitionsPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateDefinitionAdminObservabilityConfigDefinitionsPostSchema,
              CreateDefinitionAdminObservabilityConfigDefinitionsPostBody,
              CreateDefinitionAdminObservabilityConfigDefinitionsPostData,
              CreateDefinitionAdminObservabilityConfigDefinitionsPostParameters,
              OperationError<CreateDefinitionAdminObservabilityConfigDefinitionsPostError>,
              TContext
            >
      ):
        | Mutation<
            CreateDefinitionAdminObservabilityConfigDefinitionsPostData,
            CreateDefinitionAdminObservabilityConfigDefinitionsPostError,
            MutationVariables<
              CreateDefinitionAdminObservabilityConfigDefinitionsPostBody,
              CreateDefinitionAdminObservabilityConfigDefinitionsPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateDefinitionAdminObservabilityConfigDefinitionsPostBody,
              CreateDefinitionAdminObservabilityConfigDefinitionsPostData,
              CreateDefinitionAdminObservabilityConfigDefinitionsPostParameters,
              OperationError<CreateDefinitionAdminObservabilityConfigDefinitionsPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateDefinitionAdminObservabilityConfigDefinitionsPostSchema,
              CreateDefinitionAdminObservabilityConfigDefinitionsPostBody,
              CreateDefinitionAdminObservabilityConfigDefinitionsPostData,
              CreateDefinitionAdminObservabilityConfigDefinitionsPostParameters,
              OperationError<CreateDefinitionAdminObservabilityConfigDefinitionsPostError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateDefinitionAdminObservabilityConfigDefinitionsPostData,
          CreateDefinitionAdminObservabilityConfigDefinitionsPostError,
          MutationVariables<
            CreateDefinitionAdminObservabilityConfigDefinitionsPostBody,
            CreateDefinitionAdminObservabilityConfigDefinitionsPostParameters
          >,
          TContext
        >
      >;
    };
    schema: CreateDefinitionAdminObservabilityConfigDefinitionsPostSchema;
    types: {
      parameters: CreateDefinitionAdminObservabilityConfigDefinitionsPostParameters;
      data: CreateDefinitionAdminObservabilityConfigDefinitionsPostData;
      error: CreateDefinitionAdminObservabilityConfigDefinitionsPostError;
      body: CreateDefinitionAdminObservabilityConfigDefinitionsPostBody;
    };
  };
  /** @summary Update Definition */
  updateDefinitionAdminObservabilityConfigDefinitionsKeyPut: {
    /** @summary Update Definition */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutBody,
        UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutSchema,
        options: ServiceOperationMutationFnOptions<
          UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutBody,
          UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutData,
          UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutError
        >
      >
    ): Promise<
      RequestFnResponse<
        UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutData,
        UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutError
      >
    >;
    /** @summary Update Definition */
    getMutationKey(
      parameters: DeepReadonly<UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutParameters> | void
    ): ServiceOperationMutationKey<
      UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutSchema,
      UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update Definition
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.metricsObservabilityService.updateDefinitionAdminObservabilityConfigDefinitionsKeyPut.useMutation({
     *     path: {
     *         key: key
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.metricsObservabilityService.updateDefinitionAdminObservabilityConfigDefinitionsKeyPut.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         key: key
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutSchema,
        UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutData,
        UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutParameters,
        TVariables,
        OperationError<UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutError>,
        TContext
      >
    ): UseMutationResult<
      UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutData,
      OperationError<UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update Definition
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.metricsObservabilityService.updateDefinitionAdminObservabilityConfigDefinitionsKeyPut.useMutation({
     *     path: {
     *         key: key
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.metricsObservabilityService.updateDefinitionAdminObservabilityConfigDefinitionsKeyPut.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         key: key
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutBody,
        UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutSchema,
        UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutData,
        UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutParameters,
        TVariables,
        OperationError<UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutError>,
        TContext
      >
    ): UseMutationResult<
      UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutData,
      OperationError<UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update Definition
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateDefinitionAdminObservabilityConfigDefinitionsKeyPutTotal = qraft.metricsObservabilityService.updateDefinitionAdminObservabilityConfigDefinitionsKeyPut.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateDefinitionAdminObservabilityConfigDefinitionsKeyPutTotal = qraft.metricsObservabilityService.updateDefinitionAdminObservabilityConfigDefinitionsKeyPut.useIsMutating({
     *     parameters: {
     *         path: {
     *             key: key
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutBody,
            UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutData,
            UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutParameters,
            OperationError<UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutSchema,
            UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutBody,
            UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutData,
            UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutParameters,
            OperationError<UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update Definition
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateDefinitionAdminObservabilityConfigDefinitionsKeyPutPendingMutationVariables = qraft.metricsObservabilityService.updateDefinitionAdminObservabilityConfigDefinitionsKeyPut.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateDefinitionAdminObservabilityConfigDefinitionsKeyPutMutationData = qraft.metricsObservabilityService.updateDefinitionAdminObservabilityConfigDefinitionsKeyPut.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 key: key
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutData,
        OperationError<UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutError>,
        MutationVariables<
          UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutBody,
          UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutBody,
            UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutData,
            UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutParameters,
            OperationError<UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutSchema,
            UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutBody,
            UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutData,
            UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutParameters,
            OperationError<UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutData,
          OperationError<UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutError>,
          MutationVariables<
            UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutBody,
            UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Update Definition */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutBody,
            UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutData,
            UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutParameters,
            OperationError<UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutSchema,
            UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutBody,
            UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutData,
            UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutParameters,
            OperationError<UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update Definition
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.metricsObservabilityService.updateDefinitionAdminObservabilityConfigDefinitionsKeyPut.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             key: key
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.metricsObservabilityService.updateDefinitionAdminObservabilityConfigDefinitionsKeyPut.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutBody,
              UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutData,
              UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutParameters,
              OperationError<UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutSchema,
              UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutBody,
              UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutData,
              UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutParameters,
              OperationError<UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutError>,
              TContext
            >
      ):
        | Mutation<
            UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutData,
            UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutError,
            MutationVariables<
              UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutBody,
              UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutBody,
              UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutData,
              UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutParameters,
              OperationError<UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutSchema,
              UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutBody,
              UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutData,
              UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutParameters,
              OperationError<UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutData,
          UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutError,
          MutationVariables<
            UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutBody,
            UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutParameters
          >,
          TContext
        >
      >;
    };
    schema: UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutSchema;
    types: {
      parameters: UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutParameters;
      data: UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutData;
      error: UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutError;
      body: UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutBody;
    };
  };
  /** @summary Get Values */
  getValuesAdminObservabilityValuesGet: {
    /** @summary Get Values */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<GetValuesAdminObservabilityValuesGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetValuesAdminObservabilityValuesGetSchema,
        options: {
          parameters: GetValuesAdminObservabilityValuesGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<GetValuesAdminObservabilityValuesGetData, GetValuesAdminObservabilityValuesGetError>
      >
    ): Promise<RequestFnResponse<GetValuesAdminObservabilityValuesGetData, GetValuesAdminObservabilityValuesGetError>>;
    /** @summary Get Values */
    getQueryKey(
      parameters: DeepReadonly<GetValuesAdminObservabilityValuesGetParameters>
    ): ServiceOperationQueryKey<
      GetValuesAdminObservabilityValuesGetSchema,
      GetValuesAdminObservabilityValuesGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Values
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.metricsObservabilityService.getValuesAdminObservabilityValuesGet.useQuery({
     *     query: {
     *         metric_keys: metricKeys,
     *         period_from: periodFrom,
     *         period_to: periodTo
     *     }
     * })
     * ```
     */
    useQuery<TData = GetValuesAdminObservabilityValuesGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetParameters
          >
        | DeepReadonly<GetValuesAdminObservabilityValuesGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetValuesAdminObservabilityValuesGetData,
          GetValuesAdminObservabilityValuesGetError,
          TData,
          ServiceOperationQueryKey<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetValuesAdminObservabilityValuesGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Values
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.metricsObservabilityService.getValuesAdminObservabilityValuesGet.useQuery({
     *     query: {
     *         metric_keys: metricKeys,
     *         period_from: periodFrom,
     *         period_to: periodTo
     *     }
     * })
     * ```
     */
    useQuery<TData = GetValuesAdminObservabilityValuesGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetParameters
          >
        | DeepReadonly<GetValuesAdminObservabilityValuesGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetValuesAdminObservabilityValuesGetData,
          GetValuesAdminObservabilityValuesGetError,
          TData,
          ServiceOperationQueryKey<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetValuesAdminObservabilityValuesGetError>>;
    /** @summary Get Values */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetValuesAdminObservabilityValuesGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      GetValuesAdminObservabilityValuesGetSchema,
      GetValuesAdminObservabilityValuesGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Values
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.metricsObservabilityService.getValuesAdminObservabilityValuesGet.useInfiniteQuery({
     *     query: {
     *         metric_keys: metricKeys,
     *         period_from: periodFrom,
     *         period_to: periodTo
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             metric_keys: initialMetricKeys,
     *             period_from: initialPeriodFrom,
     *             period_to: initialPeriodTo
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetValuesAdminObservabilityValuesGetParameters,
      TQueryFnData = GetValuesAdminObservabilityValuesGetData,
      TData = OperationInfiniteData<TQueryFnData, GetValuesAdminObservabilityValuesGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetParameters
          >
        | DeepReadonly<GetValuesAdminObservabilityValuesGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetValuesAdminObservabilityValuesGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetValuesAdminObservabilityValuesGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Values
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.metricsObservabilityService.getValuesAdminObservabilityValuesGet.useInfiniteQuery({
     *     query: {
     *         metric_keys: metricKeys,
     *         period_from: periodFrom,
     *         period_to: periodTo
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             metric_keys: initialMetricKeys,
     *             period_from: initialPeriodFrom,
     *             period_to: initialPeriodTo
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetValuesAdminObservabilityValuesGetParameters,
      TQueryFnData = GetValuesAdminObservabilityValuesGetData,
      TData = OperationInfiniteData<TQueryFnData, GetValuesAdminObservabilityValuesGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetParameters
          >
        | DeepReadonly<GetValuesAdminObservabilityValuesGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetValuesAdminObservabilityValuesGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetValuesAdminObservabilityValuesGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetValuesAdminObservabilityValuesGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Values
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getValuesAdminObservabilityValuesGetTotal = qraft.metricsObservabilityService.getValuesAdminObservabilityValuesGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getValuesAdminObservabilityValuesGetByParametersTotal = qraft.metricsObservabilityService.getValuesAdminObservabilityValuesGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             metric_keys: metricKeys,
     *             period_from: periodFrom,
     *             period_to: periodTo
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetData,
            TInfinite,
            GetValuesAdminObservabilityValuesGetParameters,
            GetValuesAdminObservabilityValuesGetError
          >
        | QueryFiltersByQueryKey<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetData,
            TInfinite,
            GetValuesAdminObservabilityValuesGetParameters,
            GetValuesAdminObservabilityValuesGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Values
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getValuesAdminObservabilityValuesGetResults = qraft.metricsObservabilityService.getValuesAdminObservabilityValuesGet.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 metric_keys: metricKeys1,
     *                 period_from: periodFrom1,
     *                 period_to: periodTo1
     *             }
     *         },
     *         {
     *             query: {
     *                 metric_keys: metricKeys2,
     *                 period_from: periodFrom2,
     *                 period_to: periodTo2
     *             }
     *         }
     *     ]
     * });
     * getValuesAdminObservabilityValuesGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getValuesAdminObservabilityValuesGetCombinedResults = qraft.metricsObservabilityService.getValuesAdminObservabilityValuesGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 metric_keys: metricKeys1,
     *                 period_from: periodFrom1,
     *                 period_to: periodTo1
     *             }
     *         },
     *         {
     *             query: {
     *                 metric_keys: metricKeys2,
     *                 period_from: periodFrom2,
     *                 period_to: periodTo2
     *             }
     *         }
     *     ]
     * });
     * getValuesAdminObservabilityValuesGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetValuesAdminObservabilityValuesGetSchema,
          GetValuesAdminObservabilityValuesGetParameters,
          GetValuesAdminObservabilityValuesGetData,
          GetValuesAdminObservabilityValuesGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<GetValuesAdminObservabilityValuesGetData, GetValuesAdminObservabilityValuesGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<GetValuesAdminObservabilityValuesGetData, GetValuesAdminObservabilityValuesGetError>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Values
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.metricsObservabilityService.getValuesAdminObservabilityValuesGet.useSuspenseQuery({
     *     query: {
     *         metric_keys: metricKeys,
     *         period_from: periodFrom,
     *         period_to: periodTo
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetValuesAdminObservabilityValuesGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetParameters
          >
        | DeepReadonly<GetValuesAdminObservabilityValuesGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetValuesAdminObservabilityValuesGetData,
          GetValuesAdminObservabilityValuesGetError,
          TData,
          ServiceOperationQueryKey<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetValuesAdminObservabilityValuesGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Values
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.metricsObservabilityService.getValuesAdminObservabilityValuesGet.useSuspenseInfiniteQuery({
     *     query: {
     *         metric_keys: metricKeys,
     *         period_from: periodFrom,
     *         period_to: periodTo
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             metric_keys: initialMetricKeys,
     *             period_from: initialPeriodFrom,
     *             period_to: initialPeriodTo
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetValuesAdminObservabilityValuesGetParameters,
      TData = GetValuesAdminObservabilityValuesGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetParameters
          >
        | DeepReadonly<GetValuesAdminObservabilityValuesGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetValuesAdminObservabilityValuesGetData,
          GetValuesAdminObservabilityValuesGetError,
          OperationInfiniteData<TData, GetValuesAdminObservabilityValuesGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetValuesAdminObservabilityValuesGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetValuesAdminObservabilityValuesGetParameters>,
      OperationError<GetValuesAdminObservabilityValuesGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Values
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getValuesAdminObservabilityValuesGetData = qraft.metricsObservabilityService.getValuesAdminObservabilityValuesGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 metric_keys: metricKeys1,
     *                 period_from: periodFrom1,
     *                 period_to: periodTo1
     *             }
     *         },
     *         {
     *             query: {
     *                 metric_keys: metricKeys2,
     *                 period_from: periodFrom2,
     *                 period_to: periodTo2
     *             }
     *         }
     *     ]
     * });
     * getValuesAdminObservabilityValuesGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getValuesAdminObservabilityValuesGetCombinedData = qraft.metricsObservabilityService.getValuesAdminObservabilityValuesGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 metric_keys: metricKeys1,
     *                 period_from: periodFrom1,
     *                 period_to: periodTo1
     *             }
     *         },
     *         {
     *             query: {
     *                 metric_keys: metricKeys2,
     *                 period_from: periodFrom2,
     *                 period_to: periodTo2
     *             }
     *         }
     *     ]
     * });
     * getValuesAdminObservabilityValuesGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetValuesAdminObservabilityValuesGetSchema,
          GetValuesAdminObservabilityValuesGetParameters,
          GetValuesAdminObservabilityValuesGetData,
          GetValuesAdminObservabilityValuesGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<GetValuesAdminObservabilityValuesGetData, GetValuesAdminObservabilityValuesGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<GetValuesAdminObservabilityValuesGetData, GetValuesAdminObservabilityValuesGetError>,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get Values */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetValuesAdminObservabilityValuesGetSchema,
        GetValuesAdminObservabilityValuesGetData,
        GetValuesAdminObservabilityValuesGetParameters,
        GetValuesAdminObservabilityValuesGetError
      >
    ): Promise<GetValuesAdminObservabilityValuesGetData>;
    /** @summary Get Values */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetValuesAdminObservabilityValuesGetSchema,
        GetValuesAdminObservabilityValuesGetData,
        GetValuesAdminObservabilityValuesGetParameters,
        GetValuesAdminObservabilityValuesGetError
      >
    ): Promise<void>;
    /** @summary Get Values */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetValuesAdminObservabilityValuesGetSchema,
        GetValuesAdminObservabilityValuesGetData,
        GetValuesAdminObservabilityValuesGetParameters,
        GetValuesAdminObservabilityValuesGetError
      >
    ): Promise<GetValuesAdminObservabilityValuesGetData>;
    /** @summary Get Values */
    fetchInfiniteQuery<TPageParam extends GetValuesAdminObservabilityValuesGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetValuesAdminObservabilityValuesGetSchema,
        GetValuesAdminObservabilityValuesGetData,
        GetValuesAdminObservabilityValuesGetParameters,
        DeepReadonly<TPageParam>,
        GetValuesAdminObservabilityValuesGetError
      >
    ): Promise<
      OperationInfiniteData<GetValuesAdminObservabilityValuesGetData, GetValuesAdminObservabilityValuesGetParameters>
    >;
    /** @summary Get Values */
    prefetchInfiniteQuery<TPageParam extends GetValuesAdminObservabilityValuesGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetValuesAdminObservabilityValuesGetSchema,
        GetValuesAdminObservabilityValuesGetData,
        GetValuesAdminObservabilityValuesGetParameters,
        DeepReadonly<TPageParam>,
        GetValuesAdminObservabilityValuesGetError
      >
    ): Promise<void>;
    /** @summary Get Values */
    ensureInfiniteQueryData<TPageParam extends GetValuesAdminObservabilityValuesGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetValuesAdminObservabilityValuesGetSchema,
        GetValuesAdminObservabilityValuesGetData,
        GetValuesAdminObservabilityValuesGetParameters,
        DeepReadonly<TPageParam>,
        GetValuesAdminObservabilityValuesGetError
      >
    ): Promise<
      OperationInfiniteData<GetValuesAdminObservabilityValuesGetData, GetValuesAdminObservabilityValuesGetParameters>
    >;
    /** @summary Get Values */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetParameters
          >
        | DeepReadonly<GetValuesAdminObservabilityValuesGetParameters>
    ): GetValuesAdminObservabilityValuesGetData | undefined;
    /** @summary Get Values */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetParameters
          >
        | DeepReadonly<GetValuesAdminObservabilityValuesGetParameters>
    ):
      | OperationInfiniteData<GetValuesAdminObservabilityValuesGetData, GetValuesAdminObservabilityValuesGetParameters>
      | undefined;
    /** @summary Get Values */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetData,
            TInfinite,
            GetValuesAdminObservabilityValuesGetParameters,
            GetValuesAdminObservabilityValuesGetError
          >
        | QueryFiltersByQueryKey<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetData,
            TInfinite,
            GetValuesAdminObservabilityValuesGetParameters,
            GetValuesAdminObservabilityValuesGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetValuesAdminObservabilityValuesGetSchema,
              GetValuesAdminObservabilityValuesGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetValuesAdminObservabilityValuesGetData,
                    GetValuesAdminObservabilityValuesGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetValuesAdminObservabilityValuesGetSchema,
              GetValuesAdminObservabilityValuesGetParameters
            >,
            data: GetValuesAdminObservabilityValuesGetData | undefined,
          ]
        >;
    /** @summary Get Values */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetParameters
          >
        | DeepReadonly<GetValuesAdminObservabilityValuesGetParameters>
    ): QueryState<GetValuesAdminObservabilityValuesGetData, GetValuesAdminObservabilityValuesGetError> | undefined;
    /** @summary Get Values */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetValuesAdminObservabilityValuesGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            GetValuesAdminObservabilityValuesGetData,
            GetValuesAdminObservabilityValuesGetParameters
          >,
          GetValuesAdminObservabilityValuesGetError
        >
      | undefined;
    /** @summary Get Values */
    setQueryData(
      parameters:
        | DeepReadonly<GetValuesAdminObservabilityValuesGetParameters>
        | ServiceOperationQueryKey<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetParameters
          >,
      updater: Updater<
        NoInfer<GetValuesAdminObservabilityValuesGetData> | undefined,
        NoInfer<DeepReadonly<GetValuesAdminObservabilityValuesGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetValuesAdminObservabilityValuesGetData | undefined;
    /** @summary Get Values */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetValuesAdminObservabilityValuesGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              GetValuesAdminObservabilityValuesGetData,
              GetValuesAdminObservabilityValuesGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetValuesAdminObservabilityValuesGetData,
                GetValuesAdminObservabilityValuesGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<GetValuesAdminObservabilityValuesGetData, GetValuesAdminObservabilityValuesGetParameters>
      | undefined;
    /** @summary Get Values */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetData,
            TInfinite,
            GetValuesAdminObservabilityValuesGetParameters,
            GetValuesAdminObservabilityValuesGetError
          >
        | QueryFiltersByQueryKey<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetData,
            TInfinite,
            GetValuesAdminObservabilityValuesGetParameters,
            GetValuesAdminObservabilityValuesGetError
          >,
      updater: Updater<
        NoInfer<GetValuesAdminObservabilityValuesGetData> | undefined,
        NoInfer<GetValuesAdminObservabilityValuesGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetValuesAdminObservabilityValuesGetData | undefined>;
    /** @summary Get Values */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetValuesAdminObservabilityValuesGetSchema,
        GetValuesAdminObservabilityValuesGetData,
        TInfinite,
        GetValuesAdminObservabilityValuesGetParameters,
        GetValuesAdminObservabilityValuesGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get Values */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetData,
            TInfinite,
            GetValuesAdminObservabilityValuesGetParameters,
            GetValuesAdminObservabilityValuesGetError
          >
        | QueryFiltersByQueryKey<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetData,
            TInfinite,
            GetValuesAdminObservabilityValuesGetParameters,
            GetValuesAdminObservabilityValuesGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get Values */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetData,
            TInfinite,
            GetValuesAdminObservabilityValuesGetParameters,
            GetValuesAdminObservabilityValuesGetError
          >
        | QueryFiltersByQueryKey<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetData,
            TInfinite,
            GetValuesAdminObservabilityValuesGetParameters,
            GetValuesAdminObservabilityValuesGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get Values */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetData,
            TInfinite,
            GetValuesAdminObservabilityValuesGetParameters,
            GetValuesAdminObservabilityValuesGetError
          >
        | QueryFiltersByQueryKey<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetData,
            TInfinite,
            GetValuesAdminObservabilityValuesGetParameters,
            GetValuesAdminObservabilityValuesGetError
          >
    ): void;
    /** @summary Get Values */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetData,
            TInfinite,
            GetValuesAdminObservabilityValuesGetParameters,
            GetValuesAdminObservabilityValuesGetError
          >
        | QueryFiltersByQueryKey<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetData,
            TInfinite,
            GetValuesAdminObservabilityValuesGetParameters,
            GetValuesAdminObservabilityValuesGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get Values */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetData,
            TInfinite,
            GetValuesAdminObservabilityValuesGetParameters,
            GetValuesAdminObservabilityValuesGetError
          >
        | QueryFiltersByQueryKey<
            GetValuesAdminObservabilityValuesGetSchema,
            GetValuesAdminObservabilityValuesGetData,
            TInfinite,
            GetValuesAdminObservabilityValuesGetParameters,
            GetValuesAdminObservabilityValuesGetError
          >
    ): number;
    schema: GetValuesAdminObservabilityValuesGetSchema;
    types: {
      parameters: GetValuesAdminObservabilityValuesGetParameters;
      data: GetValuesAdminObservabilityValuesGetData;
      error: GetValuesAdminObservabilityValuesGetError;
    };
  };
  /**
   * @summary Get Values Baseline
   * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
   * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
   * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
   */
  getValuesBaselineAdminObservabilityValuesBaselineGet: {
    /**
     * @summary Get Values Baseline
     * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
     * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
     * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<GetValuesBaselineAdminObservabilityValuesBaselineGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
        options: {
          parameters: GetValuesBaselineAdminObservabilityValuesBaselineGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          GetValuesBaselineAdminObservabilityValuesBaselineGetData,
          GetValuesBaselineAdminObservabilityValuesBaselineGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        GetValuesBaselineAdminObservabilityValuesBaselineGetData,
        GetValuesBaselineAdminObservabilityValuesBaselineGetError
      >
    >;
    /**
     * @summary Get Values Baseline
     * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
     * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
     * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
     */
    getQueryKey(
      parameters: DeepReadonly<GetValuesBaselineAdminObservabilityValuesBaselineGetParameters>
    ): ServiceOperationQueryKey<
      GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
      GetValuesBaselineAdminObservabilityValuesBaselineGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Values Baseline
     * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
     * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
     * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.metricsObservabilityService.getValuesBaselineAdminObservabilityValuesBaselineGet.useQuery({
     *     query: {
     *         metric_keys: metricKeys,
     *         period_from: periodFrom,
     *         period_to: periodTo
     *     }
     * })
     * ```
     */
    useQuery<TData = GetValuesBaselineAdminObservabilityValuesBaselineGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters
          >
        | DeepReadonly<GetValuesBaselineAdminObservabilityValuesBaselineGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetValuesBaselineAdminObservabilityValuesBaselineGetData,
          GetValuesBaselineAdminObservabilityValuesBaselineGetError,
          TData,
          ServiceOperationQueryKey<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetValuesBaselineAdminObservabilityValuesBaselineGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Values Baseline
     * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
     * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
     * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.metricsObservabilityService.getValuesBaselineAdminObservabilityValuesBaselineGet.useQuery({
     *     query: {
     *         metric_keys: metricKeys,
     *         period_from: periodFrom,
     *         period_to: periodTo
     *     }
     * })
     * ```
     */
    useQuery<TData = GetValuesBaselineAdminObservabilityValuesBaselineGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters
          >
        | DeepReadonly<GetValuesBaselineAdminObservabilityValuesBaselineGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetValuesBaselineAdminObservabilityValuesBaselineGetData,
          GetValuesBaselineAdminObservabilityValuesBaselineGetError,
          TData,
          ServiceOperationQueryKey<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetValuesBaselineAdminObservabilityValuesBaselineGetError>>;
    /**
     * @summary Get Values Baseline
     * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
     * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
     * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetValuesBaselineAdminObservabilityValuesBaselineGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
      GetValuesBaselineAdminObservabilityValuesBaselineGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Values Baseline
     * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
     * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
     * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.metricsObservabilityService.getValuesBaselineAdminObservabilityValuesBaselineGet.useInfiniteQuery({
     *     query: {
     *         metric_keys: metricKeys,
     *         period_from: periodFrom,
     *         period_to: periodTo
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             metric_keys: initialMetricKeys,
     *             period_from: initialPeriodFrom,
     *             period_to: initialPeriodTo
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetValuesBaselineAdminObservabilityValuesBaselineGetParameters,
      TQueryFnData = GetValuesBaselineAdminObservabilityValuesBaselineGetData,
      TData = OperationInfiniteData<TQueryFnData, GetValuesBaselineAdminObservabilityValuesBaselineGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters
          >
        | DeepReadonly<GetValuesBaselineAdminObservabilityValuesBaselineGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetValuesBaselineAdminObservabilityValuesBaselineGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetValuesBaselineAdminObservabilityValuesBaselineGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Values Baseline
     * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
     * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
     * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.metricsObservabilityService.getValuesBaselineAdminObservabilityValuesBaselineGet.useInfiniteQuery({
     *     query: {
     *         metric_keys: metricKeys,
     *         period_from: periodFrom,
     *         period_to: periodTo
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             metric_keys: initialMetricKeys,
     *             period_from: initialPeriodFrom,
     *             period_to: initialPeriodTo
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetValuesBaselineAdminObservabilityValuesBaselineGetParameters,
      TQueryFnData = GetValuesBaselineAdminObservabilityValuesBaselineGetData,
      TData = OperationInfiniteData<TQueryFnData, GetValuesBaselineAdminObservabilityValuesBaselineGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters
          >
        | DeepReadonly<GetValuesBaselineAdminObservabilityValuesBaselineGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetValuesBaselineAdminObservabilityValuesBaselineGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetValuesBaselineAdminObservabilityValuesBaselineGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetValuesBaselineAdminObservabilityValuesBaselineGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Values Baseline
     * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
     * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
     * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getValuesBaselineAdminObservabilityValuesBaselineGetTotal = qraft.metricsObservabilityService.getValuesBaselineAdminObservabilityValuesBaselineGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getValuesBaselineAdminObservabilityValuesBaselineGetByParametersTotal = qraft.metricsObservabilityService.getValuesBaselineAdminObservabilityValuesBaselineGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             metric_keys: metricKeys,
     *             period_from: periodFrom,
     *             period_to: periodTo
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetData,
            TInfinite,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters,
            GetValuesBaselineAdminObservabilityValuesBaselineGetError
          >
        | QueryFiltersByQueryKey<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetData,
            TInfinite,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters,
            GetValuesBaselineAdminObservabilityValuesBaselineGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Values Baseline
     * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
     * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
     * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getValuesBaselineAdminObservabilityValuesBaselineGetResults = qraft.metricsObservabilityService.getValuesBaselineAdminObservabilityValuesBaselineGet.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 metric_keys: metricKeys1,
     *                 period_from: periodFrom1,
     *                 period_to: periodTo1
     *             }
     *         },
     *         {
     *             query: {
     *                 metric_keys: metricKeys2,
     *                 period_from: periodFrom2,
     *                 period_to: periodTo2
     *             }
     *         }
     *     ]
     * });
     * getValuesBaselineAdminObservabilityValuesBaselineGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getValuesBaselineAdminObservabilityValuesBaselineGetCombinedResults = qraft.metricsObservabilityService.getValuesBaselineAdminObservabilityValuesBaselineGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 metric_keys: metricKeys1,
     *                 period_from: periodFrom1,
     *                 period_to: periodTo1
     *             }
     *         },
     *         {
     *             query: {
     *                 metric_keys: metricKeys2,
     *                 period_from: periodFrom2,
     *                 period_to: periodTo2
     *             }
     *         }
     *     ]
     * });
     * getValuesBaselineAdminObservabilityValuesBaselineGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
          GetValuesBaselineAdminObservabilityValuesBaselineGetParameters,
          GetValuesBaselineAdminObservabilityValuesBaselineGetData,
          GetValuesBaselineAdminObservabilityValuesBaselineGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          GetValuesBaselineAdminObservabilityValuesBaselineGetData,
          GetValuesBaselineAdminObservabilityValuesBaselineGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            GetValuesBaselineAdminObservabilityValuesBaselineGetData,
            GetValuesBaselineAdminObservabilityValuesBaselineGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Values Baseline
     * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
     * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
     * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.metricsObservabilityService.getValuesBaselineAdminObservabilityValuesBaselineGet.useSuspenseQuery({
     *     query: {
     *         metric_keys: metricKeys,
     *         period_from: periodFrom,
     *         period_to: periodTo
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetValuesBaselineAdminObservabilityValuesBaselineGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters
          >
        | DeepReadonly<GetValuesBaselineAdminObservabilityValuesBaselineGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetValuesBaselineAdminObservabilityValuesBaselineGetData,
          GetValuesBaselineAdminObservabilityValuesBaselineGetError,
          TData,
          ServiceOperationQueryKey<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetValuesBaselineAdminObservabilityValuesBaselineGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Values Baseline
     * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
     * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
     * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.metricsObservabilityService.getValuesBaselineAdminObservabilityValuesBaselineGet.useSuspenseInfiniteQuery({
     *     query: {
     *         metric_keys: metricKeys,
     *         period_from: periodFrom,
     *         period_to: periodTo
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             metric_keys: initialMetricKeys,
     *             period_from: initialPeriodFrom,
     *             period_to: initialPeriodTo
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetValuesBaselineAdminObservabilityValuesBaselineGetParameters,
      TData = GetValuesBaselineAdminObservabilityValuesBaselineGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters
          >
        | DeepReadonly<GetValuesBaselineAdminObservabilityValuesBaselineGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetValuesBaselineAdminObservabilityValuesBaselineGetData,
          GetValuesBaselineAdminObservabilityValuesBaselineGetError,
          OperationInfiniteData<TData, GetValuesBaselineAdminObservabilityValuesBaselineGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetValuesBaselineAdminObservabilityValuesBaselineGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetValuesBaselineAdminObservabilityValuesBaselineGetParameters>,
      OperationError<GetValuesBaselineAdminObservabilityValuesBaselineGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Values Baseline
     * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
     * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
     * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getValuesBaselineAdminObservabilityValuesBaselineGetData = qraft.metricsObservabilityService.getValuesBaselineAdminObservabilityValuesBaselineGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 metric_keys: metricKeys1,
     *                 period_from: periodFrom1,
     *                 period_to: periodTo1
     *             }
     *         },
     *         {
     *             query: {
     *                 metric_keys: metricKeys2,
     *                 period_from: periodFrom2,
     *                 period_to: periodTo2
     *             }
     *         }
     *     ]
     * });
     * getValuesBaselineAdminObservabilityValuesBaselineGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getValuesBaselineAdminObservabilityValuesBaselineGetCombinedData = qraft.metricsObservabilityService.getValuesBaselineAdminObservabilityValuesBaselineGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 metric_keys: metricKeys1,
     *                 period_from: periodFrom1,
     *                 period_to: periodTo1
     *             }
     *         },
     *         {
     *             query: {
     *                 metric_keys: metricKeys2,
     *                 period_from: periodFrom2,
     *                 period_to: periodTo2
     *             }
     *         }
     *     ]
     * });
     * getValuesBaselineAdminObservabilityValuesBaselineGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
          GetValuesBaselineAdminObservabilityValuesBaselineGetParameters,
          GetValuesBaselineAdminObservabilityValuesBaselineGetData,
          GetValuesBaselineAdminObservabilityValuesBaselineGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          GetValuesBaselineAdminObservabilityValuesBaselineGetData,
          GetValuesBaselineAdminObservabilityValuesBaselineGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              GetValuesBaselineAdminObservabilityValuesBaselineGetData,
              GetValuesBaselineAdminObservabilityValuesBaselineGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get Values Baseline
     * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
     * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
     * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
        GetValuesBaselineAdminObservabilityValuesBaselineGetData,
        GetValuesBaselineAdminObservabilityValuesBaselineGetParameters,
        GetValuesBaselineAdminObservabilityValuesBaselineGetError
      >
    ): Promise<GetValuesBaselineAdminObservabilityValuesBaselineGetData>;
    /**
     * @summary Get Values Baseline
     * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
     * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
     * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
        GetValuesBaselineAdminObservabilityValuesBaselineGetData,
        GetValuesBaselineAdminObservabilityValuesBaselineGetParameters,
        GetValuesBaselineAdminObservabilityValuesBaselineGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Values Baseline
     * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
     * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
     * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
        GetValuesBaselineAdminObservabilityValuesBaselineGetData,
        GetValuesBaselineAdminObservabilityValuesBaselineGetParameters,
        GetValuesBaselineAdminObservabilityValuesBaselineGetError
      >
    ): Promise<GetValuesBaselineAdminObservabilityValuesBaselineGetData>;
    /**
     * @summary Get Values Baseline
     * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
     * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
     * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
     */
    fetchInfiniteQuery<TPageParam extends GetValuesBaselineAdminObservabilityValuesBaselineGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
        GetValuesBaselineAdminObservabilityValuesBaselineGetData,
        GetValuesBaselineAdminObservabilityValuesBaselineGetParameters,
        DeepReadonly<TPageParam>,
        GetValuesBaselineAdminObservabilityValuesBaselineGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetValuesBaselineAdminObservabilityValuesBaselineGetData,
        GetValuesBaselineAdminObservabilityValuesBaselineGetParameters
      >
    >;
    /**
     * @summary Get Values Baseline
     * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
     * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
     * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
     */
    prefetchInfiniteQuery<TPageParam extends GetValuesBaselineAdminObservabilityValuesBaselineGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
        GetValuesBaselineAdminObservabilityValuesBaselineGetData,
        GetValuesBaselineAdminObservabilityValuesBaselineGetParameters,
        DeepReadonly<TPageParam>,
        GetValuesBaselineAdminObservabilityValuesBaselineGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Values Baseline
     * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
     * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
     * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
     */
    ensureInfiniteQueryData<TPageParam extends GetValuesBaselineAdminObservabilityValuesBaselineGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
        GetValuesBaselineAdminObservabilityValuesBaselineGetData,
        GetValuesBaselineAdminObservabilityValuesBaselineGetParameters,
        DeepReadonly<TPageParam>,
        GetValuesBaselineAdminObservabilityValuesBaselineGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetValuesBaselineAdminObservabilityValuesBaselineGetData,
        GetValuesBaselineAdminObservabilityValuesBaselineGetParameters
      >
    >;
    /**
     * @summary Get Values Baseline
     * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
     * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
     * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters
          >
        | DeepReadonly<GetValuesBaselineAdminObservabilityValuesBaselineGetParameters>
    ): GetValuesBaselineAdminObservabilityValuesBaselineGetData | undefined;
    /**
     * @summary Get Values Baseline
     * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
     * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
     * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters
          >
        | DeepReadonly<GetValuesBaselineAdminObservabilityValuesBaselineGetParameters>
    ):
      | OperationInfiniteData<
          GetValuesBaselineAdminObservabilityValuesBaselineGetData,
          GetValuesBaselineAdminObservabilityValuesBaselineGetParameters
        >
      | undefined;
    /**
     * @summary Get Values Baseline
     * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
     * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
     * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetData,
            TInfinite,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters,
            GetValuesBaselineAdminObservabilityValuesBaselineGetError
          >
        | QueryFiltersByQueryKey<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetData,
            TInfinite,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters,
            GetValuesBaselineAdminObservabilityValuesBaselineGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
              GetValuesBaselineAdminObservabilityValuesBaselineGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetValuesBaselineAdminObservabilityValuesBaselineGetData,
                    GetValuesBaselineAdminObservabilityValuesBaselineGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
              GetValuesBaselineAdminObservabilityValuesBaselineGetParameters
            >,
            data: GetValuesBaselineAdminObservabilityValuesBaselineGetData | undefined,
          ]
        >;
    /**
     * @summary Get Values Baseline
     * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
     * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
     * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters
          >
        | DeepReadonly<GetValuesBaselineAdminObservabilityValuesBaselineGetParameters>
    ):
      | QueryState<
          GetValuesBaselineAdminObservabilityValuesBaselineGetData,
          GetValuesBaselineAdminObservabilityValuesBaselineGetError
        >
      | undefined;
    /**
     * @summary Get Values Baseline
     * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
     * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
     * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetValuesBaselineAdminObservabilityValuesBaselineGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            GetValuesBaselineAdminObservabilityValuesBaselineGetData,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters
          >,
          GetValuesBaselineAdminObservabilityValuesBaselineGetError
        >
      | undefined;
    /**
     * @summary Get Values Baseline
     * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
     * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
     * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
     */
    setQueryData(
      parameters:
        | DeepReadonly<GetValuesBaselineAdminObservabilityValuesBaselineGetParameters>
        | ServiceOperationQueryKey<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters
          >,
      updater: Updater<
        NoInfer<GetValuesBaselineAdminObservabilityValuesBaselineGetData> | undefined,
        NoInfer<DeepReadonly<GetValuesBaselineAdminObservabilityValuesBaselineGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetValuesBaselineAdminObservabilityValuesBaselineGetData | undefined;
    /**
     * @summary Get Values Baseline
     * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
     * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
     * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetValuesBaselineAdminObservabilityValuesBaselineGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              GetValuesBaselineAdminObservabilityValuesBaselineGetData,
              GetValuesBaselineAdminObservabilityValuesBaselineGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetValuesBaselineAdminObservabilityValuesBaselineGetData,
                GetValuesBaselineAdminObservabilityValuesBaselineGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          GetValuesBaselineAdminObservabilityValuesBaselineGetData,
          GetValuesBaselineAdminObservabilityValuesBaselineGetParameters
        >
      | undefined;
    /**
     * @summary Get Values Baseline
     * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
     * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
     * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetData,
            TInfinite,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters,
            GetValuesBaselineAdminObservabilityValuesBaselineGetError
          >
        | QueryFiltersByQueryKey<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetData,
            TInfinite,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters,
            GetValuesBaselineAdminObservabilityValuesBaselineGetError
          >,
      updater: Updater<
        NoInfer<GetValuesBaselineAdminObservabilityValuesBaselineGetData> | undefined,
        NoInfer<GetValuesBaselineAdminObservabilityValuesBaselineGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetValuesBaselineAdminObservabilityValuesBaselineGetData | undefined>;
    /**
     * @summary Get Values Baseline
     * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
     * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
     * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
        GetValuesBaselineAdminObservabilityValuesBaselineGetData,
        TInfinite,
        GetValuesBaselineAdminObservabilityValuesBaselineGetParameters,
        GetValuesBaselineAdminObservabilityValuesBaselineGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get Values Baseline
     * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
     * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
     * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetData,
            TInfinite,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters,
            GetValuesBaselineAdminObservabilityValuesBaselineGetError
          >
        | QueryFiltersByQueryKey<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetData,
            TInfinite,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters,
            GetValuesBaselineAdminObservabilityValuesBaselineGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get Values Baseline
     * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
     * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
     * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetData,
            TInfinite,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters,
            GetValuesBaselineAdminObservabilityValuesBaselineGetError
          >
        | QueryFiltersByQueryKey<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetData,
            TInfinite,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters,
            GetValuesBaselineAdminObservabilityValuesBaselineGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get Values Baseline
     * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
     * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
     * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetData,
            TInfinite,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters,
            GetValuesBaselineAdminObservabilityValuesBaselineGetError
          >
        | QueryFiltersByQueryKey<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetData,
            TInfinite,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters,
            GetValuesBaselineAdminObservabilityValuesBaselineGetError
          >
    ): void;
    /**
     * @summary Get Values Baseline
     * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
     * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
     * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetData,
            TInfinite,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters,
            GetValuesBaselineAdminObservabilityValuesBaselineGetError
          >
        | QueryFiltersByQueryKey<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetData,
            TInfinite,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters,
            GetValuesBaselineAdminObservabilityValuesBaselineGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get Values Baseline
     * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
     * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
     * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetData,
            TInfinite,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters,
            GetValuesBaselineAdminObservabilityValuesBaselineGetError
          >
        | QueryFiltersByQueryKey<
            GetValuesBaselineAdminObservabilityValuesBaselineGetSchema,
            GetValuesBaselineAdminObservabilityValuesBaselineGetData,
            TInfinite,
            GetValuesBaselineAdminObservabilityValuesBaselineGetParameters,
            GetValuesBaselineAdminObservabilityValuesBaselineGetError
          >
    ): number;
    schema: GetValuesBaselineAdminObservabilityValuesBaselineGetSchema;
    types: {
      parameters: GetValuesBaselineAdminObservabilityValuesBaselineGetParameters;
      data: GetValuesBaselineAdminObservabilityValuesBaselineGetData;
      error: GetValuesBaselineAdminObservabilityValuesBaselineGetError;
    };
  };
  /** @summary Compare Values */
  compareValuesAdminObservabilityValuesCompareGet: {
    /** @summary Compare Values */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<CompareValuesAdminObservabilityValuesCompareGetParameters, TMeta, TSignal>,
      client?: (
        schema: CompareValuesAdminObservabilityValuesCompareGetSchema,
        options: {
          parameters: CompareValuesAdminObservabilityValuesCompareGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          CompareValuesAdminObservabilityValuesCompareGetData,
          CompareValuesAdminObservabilityValuesCompareGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        CompareValuesAdminObservabilityValuesCompareGetData,
        CompareValuesAdminObservabilityValuesCompareGetError
      >
    >;
    /** @summary Compare Values */
    getQueryKey(
      parameters: DeepReadonly<CompareValuesAdminObservabilityValuesCompareGetParameters>
    ): ServiceOperationQueryKey<
      CompareValuesAdminObservabilityValuesCompareGetSchema,
      CompareValuesAdminObservabilityValuesCompareGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Compare Values
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.metricsObservabilityService.compareValuesAdminObservabilityValuesCompareGet.useQuery({
     *     query: {
     *         metric_keys: metricKeys,
     *         period_from: periodFrom,
     *         period_to: periodTo
     *     }
     * })
     * ```
     */
    useQuery<TData = CompareValuesAdminObservabilityValuesCompareGetData>(
      parameters:
        | ServiceOperationQueryKey<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetParameters
          >
        | DeepReadonly<CompareValuesAdminObservabilityValuesCompareGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          CompareValuesAdminObservabilityValuesCompareGetData,
          CompareValuesAdminObservabilityValuesCompareGetError,
          TData,
          ServiceOperationQueryKey<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<CompareValuesAdminObservabilityValuesCompareGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Compare Values
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.metricsObservabilityService.compareValuesAdminObservabilityValuesCompareGet.useQuery({
     *     query: {
     *         metric_keys: metricKeys,
     *         period_from: periodFrom,
     *         period_to: periodTo
     *     }
     * })
     * ```
     */
    useQuery<TData = CompareValuesAdminObservabilityValuesCompareGetData>(
      parameters:
        | ServiceOperationQueryKey<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetParameters
          >
        | DeepReadonly<CompareValuesAdminObservabilityValuesCompareGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          CompareValuesAdminObservabilityValuesCompareGetData,
          CompareValuesAdminObservabilityValuesCompareGetError,
          TData,
          ServiceOperationQueryKey<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<CompareValuesAdminObservabilityValuesCompareGetError>>;
    /** @summary Compare Values */
    getInfiniteQueryKey(
      parameters: DeepReadonly<CompareValuesAdminObservabilityValuesCompareGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      CompareValuesAdminObservabilityValuesCompareGetSchema,
      CompareValuesAdminObservabilityValuesCompareGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Compare Values
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.metricsObservabilityService.compareValuesAdminObservabilityValuesCompareGet.useInfiniteQuery({
     *     query: {
     *         metric_keys: metricKeys,
     *         period_from: periodFrom,
     *         period_to: periodTo
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             metric_keys: initialMetricKeys,
     *             period_from: initialPeriodFrom,
     *             period_to: initialPeriodTo
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends CompareValuesAdminObservabilityValuesCompareGetParameters,
      TQueryFnData = CompareValuesAdminObservabilityValuesCompareGetData,
      TData = OperationInfiniteData<TQueryFnData, CompareValuesAdminObservabilityValuesCompareGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetParameters
          >
        | DeepReadonly<CompareValuesAdminObservabilityValuesCompareGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          CompareValuesAdminObservabilityValuesCompareGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<CompareValuesAdminObservabilityValuesCompareGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Compare Values
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.metricsObservabilityService.compareValuesAdminObservabilityValuesCompareGet.useInfiniteQuery({
     *     query: {
     *         metric_keys: metricKeys,
     *         period_from: periodFrom,
     *         period_to: periodTo
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             metric_keys: initialMetricKeys,
     *             period_from: initialPeriodFrom,
     *             period_to: initialPeriodTo
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends CompareValuesAdminObservabilityValuesCompareGetParameters,
      TQueryFnData = CompareValuesAdminObservabilityValuesCompareGetData,
      TData = OperationInfiniteData<TQueryFnData, CompareValuesAdminObservabilityValuesCompareGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetParameters
          >
        | DeepReadonly<CompareValuesAdminObservabilityValuesCompareGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          CompareValuesAdminObservabilityValuesCompareGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          CompareValuesAdminObservabilityValuesCompareGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<CompareValuesAdminObservabilityValuesCompareGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Compare Values
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const compareValuesAdminObservabilityValuesCompareGetTotal = qraft.metricsObservabilityService.compareValuesAdminObservabilityValuesCompareGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const compareValuesAdminObservabilityValuesCompareGetByParametersTotal = qraft.metricsObservabilityService.compareValuesAdminObservabilityValuesCompareGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             metric_keys: metricKeys,
     *             period_from: periodFrom,
     *             period_to: periodTo
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetData,
            TInfinite,
            CompareValuesAdminObservabilityValuesCompareGetParameters,
            CompareValuesAdminObservabilityValuesCompareGetError
          >
        | QueryFiltersByQueryKey<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetData,
            TInfinite,
            CompareValuesAdminObservabilityValuesCompareGetParameters,
            CompareValuesAdminObservabilityValuesCompareGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Compare Values
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const compareValuesAdminObservabilityValuesCompareGetResults = qraft.metricsObservabilityService.compareValuesAdminObservabilityValuesCompareGet.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 metric_keys: metricKeys1,
     *                 period_from: periodFrom1,
     *                 period_to: periodTo1
     *             }
     *         },
     *         {
     *             query: {
     *                 metric_keys: metricKeys2,
     *                 period_from: periodFrom2,
     *                 period_to: periodTo2
     *             }
     *         }
     *     ]
     * });
     * compareValuesAdminObservabilityValuesCompareGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const compareValuesAdminObservabilityValuesCompareGetCombinedResults = qraft.metricsObservabilityService.compareValuesAdminObservabilityValuesCompareGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 metric_keys: metricKeys1,
     *                 period_from: periodFrom1,
     *                 period_to: periodTo1
     *             }
     *         },
     *         {
     *             query: {
     *                 metric_keys: metricKeys2,
     *                 period_from: periodFrom2,
     *                 period_to: periodTo2
     *             }
     *         }
     *     ]
     * });
     * compareValuesAdminObservabilityValuesCompareGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          CompareValuesAdminObservabilityValuesCompareGetSchema,
          CompareValuesAdminObservabilityValuesCompareGetParameters,
          CompareValuesAdminObservabilityValuesCompareGetData,
          CompareValuesAdminObservabilityValuesCompareGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          CompareValuesAdminObservabilityValuesCompareGetData,
          CompareValuesAdminObservabilityValuesCompareGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            CompareValuesAdminObservabilityValuesCompareGetData,
            CompareValuesAdminObservabilityValuesCompareGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Compare Values
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.metricsObservabilityService.compareValuesAdminObservabilityValuesCompareGet.useSuspenseQuery({
     *     query: {
     *         metric_keys: metricKeys,
     *         period_from: periodFrom,
     *         period_to: periodTo
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = CompareValuesAdminObservabilityValuesCompareGetData>(
      parameters:
        | ServiceOperationQueryKey<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetParameters
          >
        | DeepReadonly<CompareValuesAdminObservabilityValuesCompareGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          CompareValuesAdminObservabilityValuesCompareGetData,
          CompareValuesAdminObservabilityValuesCompareGetError,
          TData,
          ServiceOperationQueryKey<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<CompareValuesAdminObservabilityValuesCompareGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Compare Values
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.metricsObservabilityService.compareValuesAdminObservabilityValuesCompareGet.useSuspenseInfiniteQuery({
     *     query: {
     *         metric_keys: metricKeys,
     *         period_from: periodFrom,
     *         period_to: periodTo
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             metric_keys: initialMetricKeys,
     *             period_from: initialPeriodFrom,
     *             period_to: initialPeriodTo
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends CompareValuesAdminObservabilityValuesCompareGetParameters,
      TData = CompareValuesAdminObservabilityValuesCompareGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetParameters
          >
        | DeepReadonly<CompareValuesAdminObservabilityValuesCompareGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          CompareValuesAdminObservabilityValuesCompareGetData,
          CompareValuesAdminObservabilityValuesCompareGetError,
          OperationInfiniteData<TData, CompareValuesAdminObservabilityValuesCompareGetParameters>,
          ServiceOperationInfiniteQueryKey<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          CompareValuesAdminObservabilityValuesCompareGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, CompareValuesAdminObservabilityValuesCompareGetParameters>,
      OperationError<CompareValuesAdminObservabilityValuesCompareGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Compare Values
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const compareValuesAdminObservabilityValuesCompareGetData = qraft.metricsObservabilityService.compareValuesAdminObservabilityValuesCompareGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 metric_keys: metricKeys1,
     *                 period_from: periodFrom1,
     *                 period_to: periodTo1
     *             }
     *         },
     *         {
     *             query: {
     *                 metric_keys: metricKeys2,
     *                 period_from: periodFrom2,
     *                 period_to: periodTo2
     *             }
     *         }
     *     ]
     * });
     * compareValuesAdminObservabilityValuesCompareGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const compareValuesAdminObservabilityValuesCompareGetCombinedData = qraft.metricsObservabilityService.compareValuesAdminObservabilityValuesCompareGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 metric_keys: metricKeys1,
     *                 period_from: periodFrom1,
     *                 period_to: periodTo1
     *             }
     *         },
     *         {
     *             query: {
     *                 metric_keys: metricKeys2,
     *                 period_from: periodFrom2,
     *                 period_to: periodTo2
     *             }
     *         }
     *     ]
     * });
     * compareValuesAdminObservabilityValuesCompareGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          CompareValuesAdminObservabilityValuesCompareGetSchema,
          CompareValuesAdminObservabilityValuesCompareGetParameters,
          CompareValuesAdminObservabilityValuesCompareGetData,
          CompareValuesAdminObservabilityValuesCompareGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          CompareValuesAdminObservabilityValuesCompareGetData,
          CompareValuesAdminObservabilityValuesCompareGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              CompareValuesAdminObservabilityValuesCompareGetData,
              CompareValuesAdminObservabilityValuesCompareGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Compare Values */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        CompareValuesAdminObservabilityValuesCompareGetSchema,
        CompareValuesAdminObservabilityValuesCompareGetData,
        CompareValuesAdminObservabilityValuesCompareGetParameters,
        CompareValuesAdminObservabilityValuesCompareGetError
      >
    ): Promise<CompareValuesAdminObservabilityValuesCompareGetData>;
    /** @summary Compare Values */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        CompareValuesAdminObservabilityValuesCompareGetSchema,
        CompareValuesAdminObservabilityValuesCompareGetData,
        CompareValuesAdminObservabilityValuesCompareGetParameters,
        CompareValuesAdminObservabilityValuesCompareGetError
      >
    ): Promise<void>;
    /** @summary Compare Values */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        CompareValuesAdminObservabilityValuesCompareGetSchema,
        CompareValuesAdminObservabilityValuesCompareGetData,
        CompareValuesAdminObservabilityValuesCompareGetParameters,
        CompareValuesAdminObservabilityValuesCompareGetError
      >
    ): Promise<CompareValuesAdminObservabilityValuesCompareGetData>;
    /** @summary Compare Values */
    fetchInfiniteQuery<TPageParam extends CompareValuesAdminObservabilityValuesCompareGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        CompareValuesAdminObservabilityValuesCompareGetSchema,
        CompareValuesAdminObservabilityValuesCompareGetData,
        CompareValuesAdminObservabilityValuesCompareGetParameters,
        DeepReadonly<TPageParam>,
        CompareValuesAdminObservabilityValuesCompareGetError
      >
    ): Promise<
      OperationInfiniteData<
        CompareValuesAdminObservabilityValuesCompareGetData,
        CompareValuesAdminObservabilityValuesCompareGetParameters
      >
    >;
    /** @summary Compare Values */
    prefetchInfiniteQuery<TPageParam extends CompareValuesAdminObservabilityValuesCompareGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        CompareValuesAdminObservabilityValuesCompareGetSchema,
        CompareValuesAdminObservabilityValuesCompareGetData,
        CompareValuesAdminObservabilityValuesCompareGetParameters,
        DeepReadonly<TPageParam>,
        CompareValuesAdminObservabilityValuesCompareGetError
      >
    ): Promise<void>;
    /** @summary Compare Values */
    ensureInfiniteQueryData<TPageParam extends CompareValuesAdminObservabilityValuesCompareGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        CompareValuesAdminObservabilityValuesCompareGetSchema,
        CompareValuesAdminObservabilityValuesCompareGetData,
        CompareValuesAdminObservabilityValuesCompareGetParameters,
        DeepReadonly<TPageParam>,
        CompareValuesAdminObservabilityValuesCompareGetError
      >
    ): Promise<
      OperationInfiniteData<
        CompareValuesAdminObservabilityValuesCompareGetData,
        CompareValuesAdminObservabilityValuesCompareGetParameters
      >
    >;
    /** @summary Compare Values */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetParameters
          >
        | DeepReadonly<CompareValuesAdminObservabilityValuesCompareGetParameters>
    ): CompareValuesAdminObservabilityValuesCompareGetData | undefined;
    /** @summary Compare Values */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetParameters
          >
        | DeepReadonly<CompareValuesAdminObservabilityValuesCompareGetParameters>
    ):
      | OperationInfiniteData<
          CompareValuesAdminObservabilityValuesCompareGetData,
          CompareValuesAdminObservabilityValuesCompareGetParameters
        >
      | undefined;
    /** @summary Compare Values */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetData,
            TInfinite,
            CompareValuesAdminObservabilityValuesCompareGetParameters,
            CompareValuesAdminObservabilityValuesCompareGetError
          >
        | QueryFiltersByQueryKey<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetData,
            TInfinite,
            CompareValuesAdminObservabilityValuesCompareGetParameters,
            CompareValuesAdminObservabilityValuesCompareGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              CompareValuesAdminObservabilityValuesCompareGetSchema,
              CompareValuesAdminObservabilityValuesCompareGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    CompareValuesAdminObservabilityValuesCompareGetData,
                    CompareValuesAdminObservabilityValuesCompareGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              CompareValuesAdminObservabilityValuesCompareGetSchema,
              CompareValuesAdminObservabilityValuesCompareGetParameters
            >,
            data: CompareValuesAdminObservabilityValuesCompareGetData | undefined,
          ]
        >;
    /** @summary Compare Values */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetParameters
          >
        | DeepReadonly<CompareValuesAdminObservabilityValuesCompareGetParameters>
    ):
      | QueryState<
          CompareValuesAdminObservabilityValuesCompareGetData,
          CompareValuesAdminObservabilityValuesCompareGetError
        >
      | undefined;
    /** @summary Compare Values */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<CompareValuesAdminObservabilityValuesCompareGetParameters>
        | ServiceOperationInfiniteQueryKey<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            CompareValuesAdminObservabilityValuesCompareGetData,
            CompareValuesAdminObservabilityValuesCompareGetParameters
          >,
          CompareValuesAdminObservabilityValuesCompareGetError
        >
      | undefined;
    /** @summary Compare Values */
    setQueryData(
      parameters:
        | DeepReadonly<CompareValuesAdminObservabilityValuesCompareGetParameters>
        | ServiceOperationQueryKey<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetParameters
          >,
      updater: Updater<
        NoInfer<CompareValuesAdminObservabilityValuesCompareGetData> | undefined,
        NoInfer<DeepReadonly<CompareValuesAdminObservabilityValuesCompareGetData>> | undefined
      >,
      options?: SetDataOptions
    ): CompareValuesAdminObservabilityValuesCompareGetData | undefined;
    /** @summary Compare Values */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<CompareValuesAdminObservabilityValuesCompareGetParameters>
        | ServiceOperationInfiniteQueryKey<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              CompareValuesAdminObservabilityValuesCompareGetData,
              CompareValuesAdminObservabilityValuesCompareGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                CompareValuesAdminObservabilityValuesCompareGetData,
                CompareValuesAdminObservabilityValuesCompareGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          CompareValuesAdminObservabilityValuesCompareGetData,
          CompareValuesAdminObservabilityValuesCompareGetParameters
        >
      | undefined;
    /** @summary Compare Values */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetData,
            TInfinite,
            CompareValuesAdminObservabilityValuesCompareGetParameters,
            CompareValuesAdminObservabilityValuesCompareGetError
          >
        | QueryFiltersByQueryKey<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetData,
            TInfinite,
            CompareValuesAdminObservabilityValuesCompareGetParameters,
            CompareValuesAdminObservabilityValuesCompareGetError
          >,
      updater: Updater<
        NoInfer<CompareValuesAdminObservabilityValuesCompareGetData> | undefined,
        NoInfer<CompareValuesAdminObservabilityValuesCompareGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<CompareValuesAdminObservabilityValuesCompareGetData | undefined>;
    /** @summary Compare Values */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        CompareValuesAdminObservabilityValuesCompareGetSchema,
        CompareValuesAdminObservabilityValuesCompareGetData,
        TInfinite,
        CompareValuesAdminObservabilityValuesCompareGetParameters,
        CompareValuesAdminObservabilityValuesCompareGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Compare Values */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetData,
            TInfinite,
            CompareValuesAdminObservabilityValuesCompareGetParameters,
            CompareValuesAdminObservabilityValuesCompareGetError
          >
        | QueryFiltersByQueryKey<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetData,
            TInfinite,
            CompareValuesAdminObservabilityValuesCompareGetParameters,
            CompareValuesAdminObservabilityValuesCompareGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Compare Values */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetData,
            TInfinite,
            CompareValuesAdminObservabilityValuesCompareGetParameters,
            CompareValuesAdminObservabilityValuesCompareGetError
          >
        | QueryFiltersByQueryKey<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetData,
            TInfinite,
            CompareValuesAdminObservabilityValuesCompareGetParameters,
            CompareValuesAdminObservabilityValuesCompareGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Compare Values */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetData,
            TInfinite,
            CompareValuesAdminObservabilityValuesCompareGetParameters,
            CompareValuesAdminObservabilityValuesCompareGetError
          >
        | QueryFiltersByQueryKey<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetData,
            TInfinite,
            CompareValuesAdminObservabilityValuesCompareGetParameters,
            CompareValuesAdminObservabilityValuesCompareGetError
          >
    ): void;
    /** @summary Compare Values */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetData,
            TInfinite,
            CompareValuesAdminObservabilityValuesCompareGetParameters,
            CompareValuesAdminObservabilityValuesCompareGetError
          >
        | QueryFiltersByQueryKey<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetData,
            TInfinite,
            CompareValuesAdminObservabilityValuesCompareGetParameters,
            CompareValuesAdminObservabilityValuesCompareGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Compare Values */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetData,
            TInfinite,
            CompareValuesAdminObservabilityValuesCompareGetParameters,
            CompareValuesAdminObservabilityValuesCompareGetError
          >
        | QueryFiltersByQueryKey<
            CompareValuesAdminObservabilityValuesCompareGetSchema,
            CompareValuesAdminObservabilityValuesCompareGetData,
            TInfinite,
            CompareValuesAdminObservabilityValuesCompareGetParameters,
            CompareValuesAdminObservabilityValuesCompareGetError
          >
    ): number;
    schema: CompareValuesAdminObservabilityValuesCompareGetSchema;
    types: {
      parameters: CompareValuesAdminObservabilityValuesCompareGetParameters;
      data: CompareValuesAdminObservabilityValuesCompareGetData;
      error: CompareValuesAdminObservabilityValuesCompareGetError;
    };
  };
  /** @summary List Runs */
  listRunsAdminObservabilityRunsGet: {
    /** @summary List Runs */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            ListRunsAdminObservabilityRunsGetSchema,
            ListRunsAdminObservabilityRunsGetParameters,
            TMeta,
            TSignal
          >
        | (QueryFnOptionsByParameters<ListRunsAdminObservabilityRunsGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: ListRunsAdminObservabilityRunsGetSchema,
        options: {
          parameters: ListRunsAdminObservabilityRunsGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<ListRunsAdminObservabilityRunsGetData, ListRunsAdminObservabilityRunsGetError>>
    ): Promise<RequestFnResponse<ListRunsAdminObservabilityRunsGetData, ListRunsAdminObservabilityRunsGetError>>;
    /** @summary List Runs */
    getQueryKey(
      parameters: DeepReadonly<ListRunsAdminObservabilityRunsGetParameters> | void
    ): ServiceOperationQueryKey<ListRunsAdminObservabilityRunsGetSchema, ListRunsAdminObservabilityRunsGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Runs
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.metricsObservabilityService.listRunsAdminObservabilityRunsGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.metricsObservabilityService.listRunsAdminObservabilityRunsGet.useQuery({
     *     query: {
     *         limit: limit
     *     }
     * })
     * ```
     */
    useQuery<TData = ListRunsAdminObservabilityRunsGetData>(
      parameters:
        | ServiceOperationQueryKey<ListRunsAdminObservabilityRunsGetSchema, ListRunsAdminObservabilityRunsGetParameters>
        | (DeepReadonly<ListRunsAdminObservabilityRunsGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          ListRunsAdminObservabilityRunsGetData,
          ListRunsAdminObservabilityRunsGetError,
          TData,
          ServiceOperationQueryKey<ListRunsAdminObservabilityRunsGetSchema, ListRunsAdminObservabilityRunsGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<ListRunsAdminObservabilityRunsGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Runs
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.metricsObservabilityService.listRunsAdminObservabilityRunsGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.metricsObservabilityService.listRunsAdminObservabilityRunsGet.useQuery({
     *     query: {
     *         limit: limit
     *     }
     * })
     * ```
     */
    useQuery<TData = ListRunsAdminObservabilityRunsGetData>(
      parameters:
        | ServiceOperationQueryKey<ListRunsAdminObservabilityRunsGetSchema, ListRunsAdminObservabilityRunsGetParameters>
        | (DeepReadonly<ListRunsAdminObservabilityRunsGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          ListRunsAdminObservabilityRunsGetData,
          ListRunsAdminObservabilityRunsGetError,
          TData,
          ServiceOperationQueryKey<ListRunsAdminObservabilityRunsGetSchema, ListRunsAdminObservabilityRunsGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<ListRunsAdminObservabilityRunsGetError>>;
    /** @summary List Runs */
    getInfiniteQueryKey(
      parameters: DeepReadonly<ListRunsAdminObservabilityRunsGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<
      ListRunsAdminObservabilityRunsGetSchema,
      ListRunsAdminObservabilityRunsGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Runs
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.metricsObservabilityService.listRunsAdminObservabilityRunsGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             limit: initialLimit
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListRunsAdminObservabilityRunsGetParameters,
      TQueryFnData = ListRunsAdminObservabilityRunsGetData,
      TData = OperationInfiniteData<TQueryFnData, ListRunsAdminObservabilityRunsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListRunsAdminObservabilityRunsGetSchema,
            ListRunsAdminObservabilityRunsGetParameters
          >
        | (DeepReadonly<ListRunsAdminObservabilityRunsGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListRunsAdminObservabilityRunsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            ListRunsAdminObservabilityRunsGetSchema,
            ListRunsAdminObservabilityRunsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<ListRunsAdminObservabilityRunsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Runs
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.metricsObservabilityService.listRunsAdminObservabilityRunsGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             limit: initialLimit
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListRunsAdminObservabilityRunsGetParameters,
      TQueryFnData = ListRunsAdminObservabilityRunsGetData,
      TData = OperationInfiniteData<TQueryFnData, ListRunsAdminObservabilityRunsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListRunsAdminObservabilityRunsGetSchema,
            ListRunsAdminObservabilityRunsGetParameters
          >
        | (DeepReadonly<ListRunsAdminObservabilityRunsGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListRunsAdminObservabilityRunsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            ListRunsAdminObservabilityRunsGetSchema,
            ListRunsAdminObservabilityRunsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          ListRunsAdminObservabilityRunsGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<ListRunsAdminObservabilityRunsGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary List Runs
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const listRunsAdminObservabilityRunsGetTotal = qraft.metricsObservabilityService.listRunsAdminObservabilityRunsGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const listRunsAdminObservabilityRunsGetByParametersTotal = qraft.metricsObservabilityService.listRunsAdminObservabilityRunsGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             limit: limit
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListRunsAdminObservabilityRunsGetSchema,
            ListRunsAdminObservabilityRunsGetData,
            TInfinite,
            ListRunsAdminObservabilityRunsGetParameters,
            ListRunsAdminObservabilityRunsGetError
          >
        | QueryFiltersByQueryKey<
            ListRunsAdminObservabilityRunsGetSchema,
            ListRunsAdminObservabilityRunsGetData,
            TInfinite,
            ListRunsAdminObservabilityRunsGetParameters,
            ListRunsAdminObservabilityRunsGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary List Runs
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const listRunsAdminObservabilityRunsGetResults = qraft.metricsObservabilityService.listRunsAdminObservabilityRunsGet.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 limit: limit1
     *             }
     *         },
     *         {
     *             query: {
     *                 limit: limit2
     *             }
     *         }
     *     ]
     * });
     * listRunsAdminObservabilityRunsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const listRunsAdminObservabilityRunsGetCombinedResults = qraft.metricsObservabilityService.listRunsAdminObservabilityRunsGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 limit: limit1
     *             }
     *         },
     *         {
     *             query: {
     *                 limit: limit2
     *             }
     *         }
     *     ]
     * });
     * listRunsAdminObservabilityRunsGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          ListRunsAdminObservabilityRunsGetSchema,
          ListRunsAdminObservabilityRunsGetParameters,
          ListRunsAdminObservabilityRunsGetData,
          ListRunsAdminObservabilityRunsGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<ListRunsAdminObservabilityRunsGetData, ListRunsAdminObservabilityRunsGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<ListRunsAdminObservabilityRunsGetData, ListRunsAdminObservabilityRunsGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary List Runs
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.metricsObservabilityService.listRunsAdminObservabilityRunsGet.useSuspenseQuery()
     * ```
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.metricsObservabilityService.listRunsAdminObservabilityRunsGet.useSuspenseQuery({
     *     query: {
     *         limit: limit
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = ListRunsAdminObservabilityRunsGetData>(
      parameters:
        | ServiceOperationQueryKey<ListRunsAdminObservabilityRunsGetSchema, ListRunsAdminObservabilityRunsGetParameters>
        | (DeepReadonly<ListRunsAdminObservabilityRunsGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          ListRunsAdminObservabilityRunsGetData,
          ListRunsAdminObservabilityRunsGetError,
          TData,
          ServiceOperationQueryKey<ListRunsAdminObservabilityRunsGetSchema, ListRunsAdminObservabilityRunsGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<ListRunsAdminObservabilityRunsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary List Runs
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.metricsObservabilityService.listRunsAdminObservabilityRunsGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             limit: initialLimit
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends ListRunsAdminObservabilityRunsGetParameters,
      TData = ListRunsAdminObservabilityRunsGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListRunsAdminObservabilityRunsGetSchema,
            ListRunsAdminObservabilityRunsGetParameters
          >
        | (DeepReadonly<ListRunsAdminObservabilityRunsGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          ListRunsAdminObservabilityRunsGetData,
          ListRunsAdminObservabilityRunsGetError,
          OperationInfiniteData<TData, ListRunsAdminObservabilityRunsGetParameters>,
          ServiceOperationInfiniteQueryKey<
            ListRunsAdminObservabilityRunsGetSchema,
            ListRunsAdminObservabilityRunsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          ListRunsAdminObservabilityRunsGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, ListRunsAdminObservabilityRunsGetParameters>,
      OperationError<ListRunsAdminObservabilityRunsGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary List Runs
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const listRunsAdminObservabilityRunsGetData = qraft.metricsObservabilityService.listRunsAdminObservabilityRunsGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 limit: limit1
     *             }
     *         },
     *         {
     *             query: {
     *                 limit: limit2
     *             }
     *         }
     *     ]
     * });
     * listRunsAdminObservabilityRunsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const listRunsAdminObservabilityRunsGetCombinedData = qraft.metricsObservabilityService.listRunsAdminObservabilityRunsGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 limit: limit1
     *             }
     *         },
     *         {
     *             query: {
     *                 limit: limit2
     *             }
     *         }
     *     ]
     * });
     * listRunsAdminObservabilityRunsGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          ListRunsAdminObservabilityRunsGetSchema,
          ListRunsAdminObservabilityRunsGetParameters,
          ListRunsAdminObservabilityRunsGetData,
          ListRunsAdminObservabilityRunsGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<ListRunsAdminObservabilityRunsGetData, ListRunsAdminObservabilityRunsGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<ListRunsAdminObservabilityRunsGetData, ListRunsAdminObservabilityRunsGetError>,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary List Runs */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListRunsAdminObservabilityRunsGetSchema,
        ListRunsAdminObservabilityRunsGetData,
        ListRunsAdminObservabilityRunsGetParameters,
        ListRunsAdminObservabilityRunsGetError
      > | void
    ): Promise<ListRunsAdminObservabilityRunsGetData>;
    /** @summary List Runs */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListRunsAdminObservabilityRunsGetSchema,
        ListRunsAdminObservabilityRunsGetData,
        ListRunsAdminObservabilityRunsGetParameters,
        ListRunsAdminObservabilityRunsGetError
      > | void
    ): Promise<void>;
    /** @summary List Runs */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        ListRunsAdminObservabilityRunsGetSchema,
        ListRunsAdminObservabilityRunsGetData,
        ListRunsAdminObservabilityRunsGetParameters,
        ListRunsAdminObservabilityRunsGetError
      > | void
    ): Promise<ListRunsAdminObservabilityRunsGetData>;
    /** @summary List Runs */
    fetchInfiniteQuery<TPageParam extends ListRunsAdminObservabilityRunsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListRunsAdminObservabilityRunsGetSchema,
        ListRunsAdminObservabilityRunsGetData,
        ListRunsAdminObservabilityRunsGetParameters,
        DeepReadonly<TPageParam>,
        ListRunsAdminObservabilityRunsGetError
      > | void
    ): Promise<
      OperationInfiniteData<ListRunsAdminObservabilityRunsGetData, ListRunsAdminObservabilityRunsGetParameters>
    >;
    /** @summary List Runs */
    prefetchInfiniteQuery<TPageParam extends ListRunsAdminObservabilityRunsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListRunsAdminObservabilityRunsGetSchema,
        ListRunsAdminObservabilityRunsGetData,
        ListRunsAdminObservabilityRunsGetParameters,
        DeepReadonly<TPageParam>,
        ListRunsAdminObservabilityRunsGetError
      > | void
    ): Promise<void>;
    /** @summary List Runs */
    ensureInfiniteQueryData<TPageParam extends ListRunsAdminObservabilityRunsGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        ListRunsAdminObservabilityRunsGetSchema,
        ListRunsAdminObservabilityRunsGetData,
        ListRunsAdminObservabilityRunsGetParameters,
        DeepReadonly<TPageParam>,
        ListRunsAdminObservabilityRunsGetError
      > | void
    ): Promise<
      OperationInfiniteData<ListRunsAdminObservabilityRunsGetData, ListRunsAdminObservabilityRunsGetParameters>
    >;
    /** @summary List Runs */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<ListRunsAdminObservabilityRunsGetSchema, ListRunsAdminObservabilityRunsGetParameters>
        | (DeepReadonly<ListRunsAdminObservabilityRunsGetParameters> | void)
    ): ListRunsAdminObservabilityRunsGetData | undefined;
    /** @summary List Runs */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListRunsAdminObservabilityRunsGetSchema,
            ListRunsAdminObservabilityRunsGetParameters
          >
        | (DeepReadonly<ListRunsAdminObservabilityRunsGetParameters> | void)
    ):
      | OperationInfiniteData<ListRunsAdminObservabilityRunsGetData, ListRunsAdminObservabilityRunsGetParameters>
      | undefined;
    /** @summary List Runs */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListRunsAdminObservabilityRunsGetSchema,
            ListRunsAdminObservabilityRunsGetData,
            TInfinite,
            ListRunsAdminObservabilityRunsGetParameters,
            ListRunsAdminObservabilityRunsGetError
          >
        | QueryFiltersByQueryKey<
            ListRunsAdminObservabilityRunsGetSchema,
            ListRunsAdminObservabilityRunsGetData,
            TInfinite,
            ListRunsAdminObservabilityRunsGetParameters,
            ListRunsAdminObservabilityRunsGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              ListRunsAdminObservabilityRunsGetSchema,
              ListRunsAdminObservabilityRunsGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    ListRunsAdminObservabilityRunsGetData,
                    ListRunsAdminObservabilityRunsGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              ListRunsAdminObservabilityRunsGetSchema,
              ListRunsAdminObservabilityRunsGetParameters
            >,
            data: ListRunsAdminObservabilityRunsGetData | undefined,
          ]
        >;
    /** @summary List Runs */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<ListRunsAdminObservabilityRunsGetSchema, ListRunsAdminObservabilityRunsGetParameters>
        | (DeepReadonly<ListRunsAdminObservabilityRunsGetParameters> | void)
    ): QueryState<ListRunsAdminObservabilityRunsGetData, ListRunsAdminObservabilityRunsGetError> | undefined;
    /** @summary List Runs */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<ListRunsAdminObservabilityRunsGetParameters>
        | ServiceOperationInfiniteQueryKey<
            ListRunsAdminObservabilityRunsGetSchema,
            ListRunsAdminObservabilityRunsGetParameters
          >
        | void
    ):
      | QueryState<
          OperationInfiniteData<ListRunsAdminObservabilityRunsGetData, ListRunsAdminObservabilityRunsGetParameters>,
          ListRunsAdminObservabilityRunsGetError
        >
      | undefined;
    /** @summary List Runs */
    setQueryData(
      parameters:
        | (DeepReadonly<ListRunsAdminObservabilityRunsGetParameters> | undefined)
        | ServiceOperationQueryKey<
            ListRunsAdminObservabilityRunsGetSchema,
            ListRunsAdminObservabilityRunsGetParameters
          >,
      updater: Updater<
        NoInfer<ListRunsAdminObservabilityRunsGetData> | undefined,
        NoInfer<DeepReadonly<ListRunsAdminObservabilityRunsGetData>> | undefined
      >,
      options?: SetDataOptions
    ): ListRunsAdminObservabilityRunsGetData | undefined;
    /** @summary List Runs */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<ListRunsAdminObservabilityRunsGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<
            ListRunsAdminObservabilityRunsGetSchema,
            ListRunsAdminObservabilityRunsGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<ListRunsAdminObservabilityRunsGetData, ListRunsAdminObservabilityRunsGetParameters>
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<ListRunsAdminObservabilityRunsGetData, ListRunsAdminObservabilityRunsGetParameters>
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<ListRunsAdminObservabilityRunsGetData, ListRunsAdminObservabilityRunsGetParameters>
      | undefined;
    /** @summary List Runs */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            ListRunsAdminObservabilityRunsGetSchema,
            ListRunsAdminObservabilityRunsGetData,
            TInfinite,
            ListRunsAdminObservabilityRunsGetParameters,
            ListRunsAdminObservabilityRunsGetError
          >
        | QueryFiltersByQueryKey<
            ListRunsAdminObservabilityRunsGetSchema,
            ListRunsAdminObservabilityRunsGetData,
            TInfinite,
            ListRunsAdminObservabilityRunsGetParameters,
            ListRunsAdminObservabilityRunsGetError
          >,
      updater: Updater<
        NoInfer<ListRunsAdminObservabilityRunsGetData> | undefined,
        NoInfer<ListRunsAdminObservabilityRunsGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<ListRunsAdminObservabilityRunsGetData | undefined>;
    /** @summary List Runs */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        ListRunsAdminObservabilityRunsGetSchema,
        ListRunsAdminObservabilityRunsGetData,
        TInfinite,
        ListRunsAdminObservabilityRunsGetParameters,
        ListRunsAdminObservabilityRunsGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary List Runs */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListRunsAdminObservabilityRunsGetSchema,
            ListRunsAdminObservabilityRunsGetData,
            TInfinite,
            ListRunsAdminObservabilityRunsGetParameters,
            ListRunsAdminObservabilityRunsGetError
          >
        | QueryFiltersByQueryKey<
            ListRunsAdminObservabilityRunsGetSchema,
            ListRunsAdminObservabilityRunsGetData,
            TInfinite,
            ListRunsAdminObservabilityRunsGetParameters,
            ListRunsAdminObservabilityRunsGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary List Runs */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListRunsAdminObservabilityRunsGetSchema,
            ListRunsAdminObservabilityRunsGetData,
            TInfinite,
            ListRunsAdminObservabilityRunsGetParameters,
            ListRunsAdminObservabilityRunsGetError
          >
        | QueryFiltersByQueryKey<
            ListRunsAdminObservabilityRunsGetSchema,
            ListRunsAdminObservabilityRunsGetData,
            TInfinite,
            ListRunsAdminObservabilityRunsGetParameters,
            ListRunsAdminObservabilityRunsGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary List Runs */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListRunsAdminObservabilityRunsGetSchema,
            ListRunsAdminObservabilityRunsGetData,
            TInfinite,
            ListRunsAdminObservabilityRunsGetParameters,
            ListRunsAdminObservabilityRunsGetError
          >
        | QueryFiltersByQueryKey<
            ListRunsAdminObservabilityRunsGetSchema,
            ListRunsAdminObservabilityRunsGetData,
            TInfinite,
            ListRunsAdminObservabilityRunsGetParameters,
            ListRunsAdminObservabilityRunsGetError
          >
    ): void;
    /** @summary List Runs */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListRunsAdminObservabilityRunsGetSchema,
            ListRunsAdminObservabilityRunsGetData,
            TInfinite,
            ListRunsAdminObservabilityRunsGetParameters,
            ListRunsAdminObservabilityRunsGetError
          >
        | QueryFiltersByQueryKey<
            ListRunsAdminObservabilityRunsGetSchema,
            ListRunsAdminObservabilityRunsGetData,
            TInfinite,
            ListRunsAdminObservabilityRunsGetParameters,
            ListRunsAdminObservabilityRunsGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary List Runs */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListRunsAdminObservabilityRunsGetSchema,
            ListRunsAdminObservabilityRunsGetData,
            TInfinite,
            ListRunsAdminObservabilityRunsGetParameters,
            ListRunsAdminObservabilityRunsGetError
          >
        | QueryFiltersByQueryKey<
            ListRunsAdminObservabilityRunsGetSchema,
            ListRunsAdminObservabilityRunsGetData,
            TInfinite,
            ListRunsAdminObservabilityRunsGetParameters,
            ListRunsAdminObservabilityRunsGetError
          >
    ): number;
    schema: ListRunsAdminObservabilityRunsGetSchema;
    types: {
      parameters: ListRunsAdminObservabilityRunsGetParameters;
      data: ListRunsAdminObservabilityRunsGetData;
      error: ListRunsAdminObservabilityRunsGetError;
    };
  };
  /** @summary Get Run */
  getRunAdminObservabilityRunsRunIdGet: {
    /** @summary Get Run */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<GetRunAdminObservabilityRunsRunIdGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetRunAdminObservabilityRunsRunIdGetSchema,
        options: {
          parameters: GetRunAdminObservabilityRunsRunIdGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<GetRunAdminObservabilityRunsRunIdGetData, GetRunAdminObservabilityRunsRunIdGetError>
      >
    ): Promise<RequestFnResponse<GetRunAdminObservabilityRunsRunIdGetData, GetRunAdminObservabilityRunsRunIdGetError>>;
    /** @summary Get Run */
    getQueryKey(
      parameters: DeepReadonly<GetRunAdminObservabilityRunsRunIdGetParameters>
    ): ServiceOperationQueryKey<
      GetRunAdminObservabilityRunsRunIdGetSchema,
      GetRunAdminObservabilityRunsRunIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Run
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.metricsObservabilityService.getRunAdminObservabilityRunsRunIdGet.useQuery({
     *     path: {
     *         run_id: runId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetRunAdminObservabilityRunsRunIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetParameters
          >
        | DeepReadonly<GetRunAdminObservabilityRunsRunIdGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetRunAdminObservabilityRunsRunIdGetData,
          GetRunAdminObservabilityRunsRunIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetRunAdminObservabilityRunsRunIdGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Run
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.metricsObservabilityService.getRunAdminObservabilityRunsRunIdGet.useQuery({
     *     path: {
     *         run_id: runId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetRunAdminObservabilityRunsRunIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetParameters
          >
        | DeepReadonly<GetRunAdminObservabilityRunsRunIdGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetRunAdminObservabilityRunsRunIdGetData,
          GetRunAdminObservabilityRunsRunIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetRunAdminObservabilityRunsRunIdGetError>>;
    /** @summary Get Run */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetRunAdminObservabilityRunsRunIdGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      GetRunAdminObservabilityRunsRunIdGetSchema,
      GetRunAdminObservabilityRunsRunIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Run
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.metricsObservabilityService.getRunAdminObservabilityRunsRunIdGet.useInfiniteQuery({
     *     path: {
     *         run_id: runId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetRunAdminObservabilityRunsRunIdGetParameters,
      TQueryFnData = GetRunAdminObservabilityRunsRunIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetRunAdminObservabilityRunsRunIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetParameters
          >
        | DeepReadonly<GetRunAdminObservabilityRunsRunIdGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetRunAdminObservabilityRunsRunIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetRunAdminObservabilityRunsRunIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Run
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.metricsObservabilityService.getRunAdminObservabilityRunsRunIdGet.useInfiniteQuery({
     *     path: {
     *         run_id: runId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetRunAdminObservabilityRunsRunIdGetParameters,
      TQueryFnData = GetRunAdminObservabilityRunsRunIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetRunAdminObservabilityRunsRunIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetParameters
          >
        | DeepReadonly<GetRunAdminObservabilityRunsRunIdGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetRunAdminObservabilityRunsRunIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetRunAdminObservabilityRunsRunIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetRunAdminObservabilityRunsRunIdGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Run
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getRunAdminObservabilityRunsRunIdGetTotal = qraft.metricsObservabilityService.getRunAdminObservabilityRunsRunIdGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getRunAdminObservabilityRunsRunIdGetByParametersTotal = qraft.metricsObservabilityService.getRunAdminObservabilityRunsRunIdGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             run_id: runId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetData,
            TInfinite,
            GetRunAdminObservabilityRunsRunIdGetParameters,
            GetRunAdminObservabilityRunsRunIdGetError
          >
        | QueryFiltersByQueryKey<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetData,
            TInfinite,
            GetRunAdminObservabilityRunsRunIdGetParameters,
            GetRunAdminObservabilityRunsRunIdGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Run
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getRunAdminObservabilityRunsRunIdGetResults = qraft.metricsObservabilityService.getRunAdminObservabilityRunsRunIdGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 run_id: runId1
     *             }
     *         },
     *         {
     *             path: {
     *                 run_id: runId2
     *             }
     *         }
     *     ]
     * });
     * getRunAdminObservabilityRunsRunIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getRunAdminObservabilityRunsRunIdGetCombinedResults = qraft.metricsObservabilityService.getRunAdminObservabilityRunsRunIdGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 run_id: runId1
     *             }
     *         },
     *         {
     *             path: {
     *                 run_id: runId2
     *             }
     *         }
     *     ]
     * });
     * getRunAdminObservabilityRunsRunIdGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetRunAdminObservabilityRunsRunIdGetSchema,
          GetRunAdminObservabilityRunsRunIdGetParameters,
          GetRunAdminObservabilityRunsRunIdGetData,
          GetRunAdminObservabilityRunsRunIdGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<GetRunAdminObservabilityRunsRunIdGetData, GetRunAdminObservabilityRunsRunIdGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<GetRunAdminObservabilityRunsRunIdGetData, GetRunAdminObservabilityRunsRunIdGetError>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Run
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.metricsObservabilityService.getRunAdminObservabilityRunsRunIdGet.useSuspenseQuery({
     *     path: {
     *         run_id: runId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetRunAdminObservabilityRunsRunIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetParameters
          >
        | DeepReadonly<GetRunAdminObservabilityRunsRunIdGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetRunAdminObservabilityRunsRunIdGetData,
          GetRunAdminObservabilityRunsRunIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetRunAdminObservabilityRunsRunIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Run
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.metricsObservabilityService.getRunAdminObservabilityRunsRunIdGet.useSuspenseInfiniteQuery({
     *     path: {
     *         run_id: runId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetRunAdminObservabilityRunsRunIdGetParameters,
      TData = GetRunAdminObservabilityRunsRunIdGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetParameters
          >
        | DeepReadonly<GetRunAdminObservabilityRunsRunIdGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetRunAdminObservabilityRunsRunIdGetData,
          GetRunAdminObservabilityRunsRunIdGetError,
          OperationInfiniteData<TData, GetRunAdminObservabilityRunsRunIdGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetRunAdminObservabilityRunsRunIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetRunAdminObservabilityRunsRunIdGetParameters>,
      OperationError<GetRunAdminObservabilityRunsRunIdGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Run
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getRunAdminObservabilityRunsRunIdGetData = qraft.metricsObservabilityService.getRunAdminObservabilityRunsRunIdGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 run_id: runId1
     *             }
     *         },
     *         {
     *             path: {
     *                 run_id: runId2
     *             }
     *         }
     *     ]
     * });
     * getRunAdminObservabilityRunsRunIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getRunAdminObservabilityRunsRunIdGetCombinedData = qraft.metricsObservabilityService.getRunAdminObservabilityRunsRunIdGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 run_id: runId1
     *             }
     *         },
     *         {
     *             path: {
     *                 run_id: runId2
     *             }
     *         }
     *     ]
     * });
     * getRunAdminObservabilityRunsRunIdGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetRunAdminObservabilityRunsRunIdGetSchema,
          GetRunAdminObservabilityRunsRunIdGetParameters,
          GetRunAdminObservabilityRunsRunIdGetData,
          GetRunAdminObservabilityRunsRunIdGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<GetRunAdminObservabilityRunsRunIdGetData, GetRunAdminObservabilityRunsRunIdGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<GetRunAdminObservabilityRunsRunIdGetData, GetRunAdminObservabilityRunsRunIdGetError>,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get Run */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetRunAdminObservabilityRunsRunIdGetSchema,
        GetRunAdminObservabilityRunsRunIdGetData,
        GetRunAdminObservabilityRunsRunIdGetParameters,
        GetRunAdminObservabilityRunsRunIdGetError
      >
    ): Promise<GetRunAdminObservabilityRunsRunIdGetData>;
    /** @summary Get Run */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetRunAdminObservabilityRunsRunIdGetSchema,
        GetRunAdminObservabilityRunsRunIdGetData,
        GetRunAdminObservabilityRunsRunIdGetParameters,
        GetRunAdminObservabilityRunsRunIdGetError
      >
    ): Promise<void>;
    /** @summary Get Run */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetRunAdminObservabilityRunsRunIdGetSchema,
        GetRunAdminObservabilityRunsRunIdGetData,
        GetRunAdminObservabilityRunsRunIdGetParameters,
        GetRunAdminObservabilityRunsRunIdGetError
      >
    ): Promise<GetRunAdminObservabilityRunsRunIdGetData>;
    /** @summary Get Run */
    fetchInfiniteQuery<TPageParam extends GetRunAdminObservabilityRunsRunIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetRunAdminObservabilityRunsRunIdGetSchema,
        GetRunAdminObservabilityRunsRunIdGetData,
        GetRunAdminObservabilityRunsRunIdGetParameters,
        DeepReadonly<TPageParam>,
        GetRunAdminObservabilityRunsRunIdGetError
      >
    ): Promise<
      OperationInfiniteData<GetRunAdminObservabilityRunsRunIdGetData, GetRunAdminObservabilityRunsRunIdGetParameters>
    >;
    /** @summary Get Run */
    prefetchInfiniteQuery<TPageParam extends GetRunAdminObservabilityRunsRunIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetRunAdminObservabilityRunsRunIdGetSchema,
        GetRunAdminObservabilityRunsRunIdGetData,
        GetRunAdminObservabilityRunsRunIdGetParameters,
        DeepReadonly<TPageParam>,
        GetRunAdminObservabilityRunsRunIdGetError
      >
    ): Promise<void>;
    /** @summary Get Run */
    ensureInfiniteQueryData<TPageParam extends GetRunAdminObservabilityRunsRunIdGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetRunAdminObservabilityRunsRunIdGetSchema,
        GetRunAdminObservabilityRunsRunIdGetData,
        GetRunAdminObservabilityRunsRunIdGetParameters,
        DeepReadonly<TPageParam>,
        GetRunAdminObservabilityRunsRunIdGetError
      >
    ): Promise<
      OperationInfiniteData<GetRunAdminObservabilityRunsRunIdGetData, GetRunAdminObservabilityRunsRunIdGetParameters>
    >;
    /** @summary Get Run */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetParameters
          >
        | DeepReadonly<GetRunAdminObservabilityRunsRunIdGetParameters>
    ): GetRunAdminObservabilityRunsRunIdGetData | undefined;
    /** @summary Get Run */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetParameters
          >
        | DeepReadonly<GetRunAdminObservabilityRunsRunIdGetParameters>
    ):
      | OperationInfiniteData<GetRunAdminObservabilityRunsRunIdGetData, GetRunAdminObservabilityRunsRunIdGetParameters>
      | undefined;
    /** @summary Get Run */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetData,
            TInfinite,
            GetRunAdminObservabilityRunsRunIdGetParameters,
            GetRunAdminObservabilityRunsRunIdGetError
          >
        | QueryFiltersByQueryKey<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetData,
            TInfinite,
            GetRunAdminObservabilityRunsRunIdGetParameters,
            GetRunAdminObservabilityRunsRunIdGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetRunAdminObservabilityRunsRunIdGetSchema,
              GetRunAdminObservabilityRunsRunIdGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetRunAdminObservabilityRunsRunIdGetData,
                    GetRunAdminObservabilityRunsRunIdGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetRunAdminObservabilityRunsRunIdGetSchema,
              GetRunAdminObservabilityRunsRunIdGetParameters
            >,
            data: GetRunAdminObservabilityRunsRunIdGetData | undefined,
          ]
        >;
    /** @summary Get Run */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetParameters
          >
        | DeepReadonly<GetRunAdminObservabilityRunsRunIdGetParameters>
    ): QueryState<GetRunAdminObservabilityRunsRunIdGetData, GetRunAdminObservabilityRunsRunIdGetError> | undefined;
    /** @summary Get Run */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetRunAdminObservabilityRunsRunIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            GetRunAdminObservabilityRunsRunIdGetData,
            GetRunAdminObservabilityRunsRunIdGetParameters
          >,
          GetRunAdminObservabilityRunsRunIdGetError
        >
      | undefined;
    /** @summary Get Run */
    setQueryData(
      parameters:
        | DeepReadonly<GetRunAdminObservabilityRunsRunIdGetParameters>
        | ServiceOperationQueryKey<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetParameters
          >,
      updater: Updater<
        NoInfer<GetRunAdminObservabilityRunsRunIdGetData> | undefined,
        NoInfer<DeepReadonly<GetRunAdminObservabilityRunsRunIdGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetRunAdminObservabilityRunsRunIdGetData | undefined;
    /** @summary Get Run */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetRunAdminObservabilityRunsRunIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              GetRunAdminObservabilityRunsRunIdGetData,
              GetRunAdminObservabilityRunsRunIdGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetRunAdminObservabilityRunsRunIdGetData,
                GetRunAdminObservabilityRunsRunIdGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<GetRunAdminObservabilityRunsRunIdGetData, GetRunAdminObservabilityRunsRunIdGetParameters>
      | undefined;
    /** @summary Get Run */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetData,
            TInfinite,
            GetRunAdminObservabilityRunsRunIdGetParameters,
            GetRunAdminObservabilityRunsRunIdGetError
          >
        | QueryFiltersByQueryKey<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetData,
            TInfinite,
            GetRunAdminObservabilityRunsRunIdGetParameters,
            GetRunAdminObservabilityRunsRunIdGetError
          >,
      updater: Updater<
        NoInfer<GetRunAdminObservabilityRunsRunIdGetData> | undefined,
        NoInfer<GetRunAdminObservabilityRunsRunIdGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetRunAdminObservabilityRunsRunIdGetData | undefined>;
    /** @summary Get Run */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetRunAdminObservabilityRunsRunIdGetSchema,
        GetRunAdminObservabilityRunsRunIdGetData,
        TInfinite,
        GetRunAdminObservabilityRunsRunIdGetParameters,
        GetRunAdminObservabilityRunsRunIdGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get Run */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetData,
            TInfinite,
            GetRunAdminObservabilityRunsRunIdGetParameters,
            GetRunAdminObservabilityRunsRunIdGetError
          >
        | QueryFiltersByQueryKey<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetData,
            TInfinite,
            GetRunAdminObservabilityRunsRunIdGetParameters,
            GetRunAdminObservabilityRunsRunIdGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get Run */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetData,
            TInfinite,
            GetRunAdminObservabilityRunsRunIdGetParameters,
            GetRunAdminObservabilityRunsRunIdGetError
          >
        | QueryFiltersByQueryKey<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetData,
            TInfinite,
            GetRunAdminObservabilityRunsRunIdGetParameters,
            GetRunAdminObservabilityRunsRunIdGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get Run */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetData,
            TInfinite,
            GetRunAdminObservabilityRunsRunIdGetParameters,
            GetRunAdminObservabilityRunsRunIdGetError
          >
        | QueryFiltersByQueryKey<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetData,
            TInfinite,
            GetRunAdminObservabilityRunsRunIdGetParameters,
            GetRunAdminObservabilityRunsRunIdGetError
          >
    ): void;
    /** @summary Get Run */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetData,
            TInfinite,
            GetRunAdminObservabilityRunsRunIdGetParameters,
            GetRunAdminObservabilityRunsRunIdGetError
          >
        | QueryFiltersByQueryKey<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetData,
            TInfinite,
            GetRunAdminObservabilityRunsRunIdGetParameters,
            GetRunAdminObservabilityRunsRunIdGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get Run */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetData,
            TInfinite,
            GetRunAdminObservabilityRunsRunIdGetParameters,
            GetRunAdminObservabilityRunsRunIdGetError
          >
        | QueryFiltersByQueryKey<
            GetRunAdminObservabilityRunsRunIdGetSchema,
            GetRunAdminObservabilityRunsRunIdGetData,
            TInfinite,
            GetRunAdminObservabilityRunsRunIdGetParameters,
            GetRunAdminObservabilityRunsRunIdGetError
          >
    ): number;
    schema: GetRunAdminObservabilityRunsRunIdGetSchema;
    types: {
      parameters: GetRunAdminObservabilityRunsRunIdGetParameters;
      data: GetRunAdminObservabilityRunsRunIdGetData;
      error: GetRunAdminObservabilityRunsRunIdGetError;
    };
  };
  /** @summary List Office Settings Versions */
  listOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGet: {
    /** @summary List Office Settings Versions */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters,
            TMeta,
            TSignal
          >
        | (QueryFnOptionsByParameters<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters,
            TMeta,
            TSignal
          > | void),
      client?: (
        schema: ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
        options: {
          parameters: ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
          ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError
      >
    >;
    /** @summary List Office Settings Versions */
    getQueryKey(
      parameters: DeepReadonly<ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters> | void
    ): ServiceOperationQueryKey<
      ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
      ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Office Settings Versions
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.metricsObservabilityService.listOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.metricsObservabilityService.listOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGet.useQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData>(
      parameters:
        | ServiceOperationQueryKey<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters
          >
        | (DeepReadonly<ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
          ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError,
          TData,
          ServiceOperationQueryKey<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<
      TData,
      OperationError<ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError>
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Office Settings Versions
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.metricsObservabilityService.listOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.metricsObservabilityService.listOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGet.useQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData>(
      parameters:
        | ServiceOperationQueryKey<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters
          >
        | (DeepReadonly<ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
          ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError,
          TData,
          ServiceOperationQueryKey<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<
      TData,
      OperationError<ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError>
    >;
    /** @summary List Office Settings Versions */
    getInfiniteQueryKey(
      parameters: DeepReadonly<ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<
      ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
      ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Office Settings Versions
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.metricsObservabilityService.listOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters,
      TQueryFnData = ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
      TData = OperationInfiniteData<
        TQueryFnData,
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters
      >,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters
          >
        | (DeepReadonly<ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<
      TData,
      OperationError<ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError>
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Office Settings Versions
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.metricsObservabilityService.listOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters,
      TQueryFnData = ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
      TData = OperationInfiniteData<
        TQueryFnData,
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters
      >,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters
          >
        | (DeepReadonly<ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<
      TData,
      OperationError<ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError>
    >;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary List Office Settings Versions
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const listOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetTotal = qraft.metricsObservabilityService.listOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const listOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetByParametersTotal = qraft.metricsObservabilityService.listOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             office_id: officeId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
            TInfinite,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError
          >
        | QueryFiltersByQueryKey<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
            TInfinite,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary List Office Settings Versions
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const listOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetResults = qraft.metricsObservabilityService.listOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGet.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * listOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const listOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetCombinedResults = qraft.metricsObservabilityService.listOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * listOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
          ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters,
          ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
          ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
          ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary List Office Settings Versions
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.metricsObservabilityService.listOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGet.useSuspenseQuery()
     * ```
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.metricsObservabilityService.listOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGet.useSuspenseQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData>(
      parameters:
        | ServiceOperationQueryKey<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters
          >
        | (DeepReadonly<ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
          ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError,
          TData,
          ServiceOperationQueryKey<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<
      TData,
      OperationError<ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError>
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary List Office Settings Versions
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.metricsObservabilityService.listOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters,
      TData = ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters
          >
        | (DeepReadonly<ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
          ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError,
          OperationInfiniteData<TData, ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters>,
          ServiceOperationInfiniteQueryKey<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters>,
      OperationError<ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary List Office Settings Versions
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const listOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData = qraft.metricsObservabilityService.listOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * listOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const listOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetCombinedData = qraft.metricsObservabilityService.listOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * listOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
          ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters,
          ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
          ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
          ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
              ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary List Office Settings Versions */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters,
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError
      > | void
    ): Promise<ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData>;
    /** @summary List Office Settings Versions */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters,
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError
      > | void
    ): Promise<void>;
    /** @summary List Office Settings Versions */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters,
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError
      > | void
    ): Promise<ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData>;
    /** @summary List Office Settings Versions */
    fetchInfiniteQuery<
      TPageParam extends ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters,
    >(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters,
        DeepReadonly<TPageParam>,
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError
      > | void
    ): Promise<
      OperationInfiniteData<
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters
      >
    >;
    /** @summary List Office Settings Versions */
    prefetchInfiniteQuery<
      TPageParam extends ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters,
    >(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters,
        DeepReadonly<TPageParam>,
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError
      > | void
    ): Promise<void>;
    /** @summary List Office Settings Versions */
    ensureInfiniteQueryData<
      TPageParam extends ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters,
    >(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters,
        DeepReadonly<TPageParam>,
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError
      > | void
    ): Promise<
      OperationInfiniteData<
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters
      >
    >;
    /** @summary List Office Settings Versions */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters
          >
        | (DeepReadonly<ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters> | void)
    ): ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData | undefined;
    /** @summary List Office Settings Versions */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters
          >
        | (DeepReadonly<ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters> | void)
    ):
      | OperationInfiniteData<
          ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
          ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters
        >
      | undefined;
    /** @summary List Office Settings Versions */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
            TInfinite,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError
          >
        | QueryFiltersByQueryKey<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
            TInfinite,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
              ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
                    ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
              ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters
            >,
            data: ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData | undefined,
          ]
        >;
    /** @summary List Office Settings Versions */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters
          >
        | (DeepReadonly<ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters> | void)
    ):
      | QueryState<
          ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
          ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError
        >
      | undefined;
    /** @summary List Office Settings Versions */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters>
        | ServiceOperationInfiniteQueryKey<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters
          >
        | void
    ):
      | QueryState<
          OperationInfiniteData<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters
          >,
          ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError
        >
      | undefined;
    /** @summary List Office Settings Versions */
    setQueryData(
      parameters:
        | (DeepReadonly<ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters> | undefined)
        | ServiceOperationQueryKey<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters
          >,
      updater: Updater<
        NoInfer<ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData> | undefined,
        NoInfer<DeepReadonly<ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData>> | undefined
      >,
      options?: SetDataOptions
    ): ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData | undefined;
    /** @summary List Office Settings Versions */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
              ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
                ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
          ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters
        >
      | undefined;
    /** @summary List Office Settings Versions */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
            TInfinite,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError
          >
        | QueryFiltersByQueryKey<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
            TInfinite,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError
          >,
      updater: Updater<
        NoInfer<ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData> | undefined,
        NoInfer<ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData | undefined>;
    /** @summary List Office Settings Versions */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
        TInfinite,
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters,
        ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary List Office Settings Versions */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
            TInfinite,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError
          >
        | QueryFiltersByQueryKey<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
            TInfinite,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary List Office Settings Versions */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
            TInfinite,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError
          >
        | QueryFiltersByQueryKey<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
            TInfinite,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary List Office Settings Versions */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
            TInfinite,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError
          >
        | QueryFiltersByQueryKey<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
            TInfinite,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError
          >
    ): void;
    /** @summary List Office Settings Versions */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
            TInfinite,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError
          >
        | QueryFiltersByQueryKey<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
            TInfinite,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary List Office Settings Versions */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
            TInfinite,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError
          >
        | QueryFiltersByQueryKey<
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData,
            TInfinite,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters,
            ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError
          >
    ): number;
    schema: ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema;
    types: {
      parameters: ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters;
      data: ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData;
      error: ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError;
    };
  };
  /** @summary Recalculate */
  recalculateAdminObservabilityConfigRecalculatePost: {
    /** @summary Recalculate */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        RecalculateAdminObservabilityConfigRecalculatePostBody,
        RecalculateAdminObservabilityConfigRecalculatePostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: RecalculateAdminObservabilityConfigRecalculatePostSchema,
        options: ServiceOperationMutationFnOptions<
          RecalculateAdminObservabilityConfigRecalculatePostBody,
          RecalculateAdminObservabilityConfigRecalculatePostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          RecalculateAdminObservabilityConfigRecalculatePostData,
          RecalculateAdminObservabilityConfigRecalculatePostError
        >
      >
    ): Promise<
      RequestFnResponse<
        RecalculateAdminObservabilityConfigRecalculatePostData,
        RecalculateAdminObservabilityConfigRecalculatePostError
      >
    >;
    /** @summary Recalculate */
    getMutationKey(
      parameters: DeepReadonly<RecalculateAdminObservabilityConfigRecalculatePostParameters> | void
    ): ServiceOperationMutationKey<
      RecalculateAdminObservabilityConfigRecalculatePostSchema,
      RecalculateAdminObservabilityConfigRecalculatePostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Recalculate
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.metricsObservabilityService.recalculateAdminObservabilityConfigRecalculatePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.metricsObservabilityService.recalculateAdminObservabilityConfigRecalculatePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends RecalculateAdminObservabilityConfigRecalculatePostBody, TContext = unknown>(
      parameters: DeepReadonly<RecalculateAdminObservabilityConfigRecalculatePostParameters>,
      options?: ServiceOperationUseMutationOptions<
        RecalculateAdminObservabilityConfigRecalculatePostSchema,
        RecalculateAdminObservabilityConfigRecalculatePostData,
        RecalculateAdminObservabilityConfigRecalculatePostParameters,
        TVariables,
        OperationError<RecalculateAdminObservabilityConfigRecalculatePostError>,
        TContext
      >
    ): UseMutationResult<
      RecalculateAdminObservabilityConfigRecalculatePostData,
      OperationError<RecalculateAdminObservabilityConfigRecalculatePostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Recalculate
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.metricsObservabilityService.recalculateAdminObservabilityConfigRecalculatePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.metricsObservabilityService.recalculateAdminObservabilityConfigRecalculatePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        RecalculateAdminObservabilityConfigRecalculatePostBody,
        RecalculateAdminObservabilityConfigRecalculatePostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        RecalculateAdminObservabilityConfigRecalculatePostSchema,
        RecalculateAdminObservabilityConfigRecalculatePostData,
        RecalculateAdminObservabilityConfigRecalculatePostParameters,
        TVariables,
        OperationError<RecalculateAdminObservabilityConfigRecalculatePostError>,
        TContext
      >
    ): UseMutationResult<
      RecalculateAdminObservabilityConfigRecalculatePostData,
      OperationError<RecalculateAdminObservabilityConfigRecalculatePostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Recalculate
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const recalculateAdminObservabilityConfigRecalculatePostTotal = qraft.metricsObservabilityService.recalculateAdminObservabilityConfigRecalculatePost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const recalculateAdminObservabilityConfigRecalculatePostTotal = qraft.metricsObservabilityService.recalculateAdminObservabilityConfigRecalculatePost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            RecalculateAdminObservabilityConfigRecalculatePostBody,
            RecalculateAdminObservabilityConfigRecalculatePostData,
            RecalculateAdminObservabilityConfigRecalculatePostParameters,
            OperationError<RecalculateAdminObservabilityConfigRecalculatePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RecalculateAdminObservabilityConfigRecalculatePostSchema,
            RecalculateAdminObservabilityConfigRecalculatePostBody,
            RecalculateAdminObservabilityConfigRecalculatePostData,
            RecalculateAdminObservabilityConfigRecalculatePostParameters,
            OperationError<RecalculateAdminObservabilityConfigRecalculatePostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Recalculate
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const recalculateAdminObservabilityConfigRecalculatePostPendingMutationVariables = qraft.metricsObservabilityService.recalculateAdminObservabilityConfigRecalculatePost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const recalculateAdminObservabilityConfigRecalculatePostMutationData = qraft.metricsObservabilityService.recalculateAdminObservabilityConfigRecalculatePost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        RecalculateAdminObservabilityConfigRecalculatePostData,
        OperationError<RecalculateAdminObservabilityConfigRecalculatePostError>,
        MutationVariables<
          RecalculateAdminObservabilityConfigRecalculatePostBody,
          RecalculateAdminObservabilityConfigRecalculatePostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            RecalculateAdminObservabilityConfigRecalculatePostBody,
            RecalculateAdminObservabilityConfigRecalculatePostData,
            RecalculateAdminObservabilityConfigRecalculatePostParameters,
            OperationError<RecalculateAdminObservabilityConfigRecalculatePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RecalculateAdminObservabilityConfigRecalculatePostSchema,
            RecalculateAdminObservabilityConfigRecalculatePostBody,
            RecalculateAdminObservabilityConfigRecalculatePostData,
            RecalculateAdminObservabilityConfigRecalculatePostParameters,
            OperationError<RecalculateAdminObservabilityConfigRecalculatePostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          RecalculateAdminObservabilityConfigRecalculatePostData,
          OperationError<RecalculateAdminObservabilityConfigRecalculatePostError>,
          MutationVariables<
            RecalculateAdminObservabilityConfigRecalculatePostBody,
            RecalculateAdminObservabilityConfigRecalculatePostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Recalculate */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            RecalculateAdminObservabilityConfigRecalculatePostBody,
            RecalculateAdminObservabilityConfigRecalculatePostData,
            RecalculateAdminObservabilityConfigRecalculatePostParameters,
            OperationError<RecalculateAdminObservabilityConfigRecalculatePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RecalculateAdminObservabilityConfigRecalculatePostSchema,
            RecalculateAdminObservabilityConfigRecalculatePostBody,
            RecalculateAdminObservabilityConfigRecalculatePostData,
            RecalculateAdminObservabilityConfigRecalculatePostParameters,
            OperationError<RecalculateAdminObservabilityConfigRecalculatePostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Recalculate
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.metricsObservabilityService.recalculateAdminObservabilityConfigRecalculatePost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.metricsObservabilityService.recalculateAdminObservabilityConfigRecalculatePost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              RecalculateAdminObservabilityConfigRecalculatePostBody,
              RecalculateAdminObservabilityConfigRecalculatePostData,
              RecalculateAdminObservabilityConfigRecalculatePostParameters,
              OperationError<RecalculateAdminObservabilityConfigRecalculatePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              RecalculateAdminObservabilityConfigRecalculatePostSchema,
              RecalculateAdminObservabilityConfigRecalculatePostBody,
              RecalculateAdminObservabilityConfigRecalculatePostData,
              RecalculateAdminObservabilityConfigRecalculatePostParameters,
              OperationError<RecalculateAdminObservabilityConfigRecalculatePostError>,
              TContext
            >
      ):
        | Mutation<
            RecalculateAdminObservabilityConfigRecalculatePostData,
            RecalculateAdminObservabilityConfigRecalculatePostError,
            MutationVariables<
              RecalculateAdminObservabilityConfigRecalculatePostBody,
              RecalculateAdminObservabilityConfigRecalculatePostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              RecalculateAdminObservabilityConfigRecalculatePostBody,
              RecalculateAdminObservabilityConfigRecalculatePostData,
              RecalculateAdminObservabilityConfigRecalculatePostParameters,
              OperationError<RecalculateAdminObservabilityConfigRecalculatePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              RecalculateAdminObservabilityConfigRecalculatePostSchema,
              RecalculateAdminObservabilityConfigRecalculatePostBody,
              RecalculateAdminObservabilityConfigRecalculatePostData,
              RecalculateAdminObservabilityConfigRecalculatePostParameters,
              OperationError<RecalculateAdminObservabilityConfigRecalculatePostError>,
              TContext
            >
      ): Array<
        Mutation<
          RecalculateAdminObservabilityConfigRecalculatePostData,
          RecalculateAdminObservabilityConfigRecalculatePostError,
          MutationVariables<
            RecalculateAdminObservabilityConfigRecalculatePostBody,
            RecalculateAdminObservabilityConfigRecalculatePostParameters
          >,
          TContext
        >
      >;
    };
    schema: RecalculateAdminObservabilityConfigRecalculatePostSchema;
    types: {
      parameters: RecalculateAdminObservabilityConfigRecalculatePostParameters;
      data: RecalculateAdminObservabilityConfigRecalculatePostData;
      error: RecalculateAdminObservabilityConfigRecalculatePostError;
      body: RecalculateAdminObservabilityConfigRecalculatePostBody;
    };
  };
  /** @summary Preview */
  previewAdminObservabilityMetricsPreviewPost: {
    /** @summary Preview */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        PreviewAdminObservabilityMetricsPreviewPostBody,
        PreviewAdminObservabilityMetricsPreviewPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: PreviewAdminObservabilityMetricsPreviewPostSchema,
        options: ServiceOperationMutationFnOptions<
          PreviewAdminObservabilityMetricsPreviewPostBody,
          PreviewAdminObservabilityMetricsPreviewPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          PreviewAdminObservabilityMetricsPreviewPostData,
          PreviewAdminObservabilityMetricsPreviewPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        PreviewAdminObservabilityMetricsPreviewPostData,
        PreviewAdminObservabilityMetricsPreviewPostError
      >
    >;
    /** @summary Preview */
    getMutationKey(
      parameters: DeepReadonly<PreviewAdminObservabilityMetricsPreviewPostParameters> | void
    ): ServiceOperationMutationKey<
      PreviewAdminObservabilityMetricsPreviewPostSchema,
      PreviewAdminObservabilityMetricsPreviewPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Preview
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.metricsObservabilityService.previewAdminObservabilityMetricsPreviewPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.metricsObservabilityService.previewAdminObservabilityMetricsPreviewPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends PreviewAdminObservabilityMetricsPreviewPostBody, TContext = unknown>(
      parameters: DeepReadonly<PreviewAdminObservabilityMetricsPreviewPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        PreviewAdminObservabilityMetricsPreviewPostSchema,
        PreviewAdminObservabilityMetricsPreviewPostData,
        PreviewAdminObservabilityMetricsPreviewPostParameters,
        TVariables,
        OperationError<PreviewAdminObservabilityMetricsPreviewPostError>,
        TContext
      >
    ): UseMutationResult<
      PreviewAdminObservabilityMetricsPreviewPostData,
      OperationError<PreviewAdminObservabilityMetricsPreviewPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Preview
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.metricsObservabilityService.previewAdminObservabilityMetricsPreviewPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.metricsObservabilityService.previewAdminObservabilityMetricsPreviewPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        PreviewAdminObservabilityMetricsPreviewPostBody,
        PreviewAdminObservabilityMetricsPreviewPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        PreviewAdminObservabilityMetricsPreviewPostSchema,
        PreviewAdminObservabilityMetricsPreviewPostData,
        PreviewAdminObservabilityMetricsPreviewPostParameters,
        TVariables,
        OperationError<PreviewAdminObservabilityMetricsPreviewPostError>,
        TContext
      >
    ): UseMutationResult<
      PreviewAdminObservabilityMetricsPreviewPostData,
      OperationError<PreviewAdminObservabilityMetricsPreviewPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Preview
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const previewAdminObservabilityMetricsPreviewPostTotal = qraft.metricsObservabilityService.previewAdminObservabilityMetricsPreviewPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const previewAdminObservabilityMetricsPreviewPostTotal = qraft.metricsObservabilityService.previewAdminObservabilityMetricsPreviewPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            PreviewAdminObservabilityMetricsPreviewPostBody,
            PreviewAdminObservabilityMetricsPreviewPostData,
            PreviewAdminObservabilityMetricsPreviewPostParameters,
            OperationError<PreviewAdminObservabilityMetricsPreviewPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            PreviewAdminObservabilityMetricsPreviewPostSchema,
            PreviewAdminObservabilityMetricsPreviewPostBody,
            PreviewAdminObservabilityMetricsPreviewPostData,
            PreviewAdminObservabilityMetricsPreviewPostParameters,
            OperationError<PreviewAdminObservabilityMetricsPreviewPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Preview
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const previewAdminObservabilityMetricsPreviewPostPendingMutationVariables = qraft.metricsObservabilityService.previewAdminObservabilityMetricsPreviewPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const previewAdminObservabilityMetricsPreviewPostMutationData = qraft.metricsObservabilityService.previewAdminObservabilityMetricsPreviewPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        PreviewAdminObservabilityMetricsPreviewPostData,
        OperationError<PreviewAdminObservabilityMetricsPreviewPostError>,
        MutationVariables<
          PreviewAdminObservabilityMetricsPreviewPostBody,
          PreviewAdminObservabilityMetricsPreviewPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            PreviewAdminObservabilityMetricsPreviewPostBody,
            PreviewAdminObservabilityMetricsPreviewPostData,
            PreviewAdminObservabilityMetricsPreviewPostParameters,
            OperationError<PreviewAdminObservabilityMetricsPreviewPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            PreviewAdminObservabilityMetricsPreviewPostSchema,
            PreviewAdminObservabilityMetricsPreviewPostBody,
            PreviewAdminObservabilityMetricsPreviewPostData,
            PreviewAdminObservabilityMetricsPreviewPostParameters,
            OperationError<PreviewAdminObservabilityMetricsPreviewPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          PreviewAdminObservabilityMetricsPreviewPostData,
          OperationError<PreviewAdminObservabilityMetricsPreviewPostError>,
          MutationVariables<
            PreviewAdminObservabilityMetricsPreviewPostBody,
            PreviewAdminObservabilityMetricsPreviewPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Preview */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            PreviewAdminObservabilityMetricsPreviewPostBody,
            PreviewAdminObservabilityMetricsPreviewPostData,
            PreviewAdminObservabilityMetricsPreviewPostParameters,
            OperationError<PreviewAdminObservabilityMetricsPreviewPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            PreviewAdminObservabilityMetricsPreviewPostSchema,
            PreviewAdminObservabilityMetricsPreviewPostBody,
            PreviewAdminObservabilityMetricsPreviewPostData,
            PreviewAdminObservabilityMetricsPreviewPostParameters,
            OperationError<PreviewAdminObservabilityMetricsPreviewPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Preview
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.metricsObservabilityService.previewAdminObservabilityMetricsPreviewPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.metricsObservabilityService.previewAdminObservabilityMetricsPreviewPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              PreviewAdminObservabilityMetricsPreviewPostBody,
              PreviewAdminObservabilityMetricsPreviewPostData,
              PreviewAdminObservabilityMetricsPreviewPostParameters,
              OperationError<PreviewAdminObservabilityMetricsPreviewPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              PreviewAdminObservabilityMetricsPreviewPostSchema,
              PreviewAdminObservabilityMetricsPreviewPostBody,
              PreviewAdminObservabilityMetricsPreviewPostData,
              PreviewAdminObservabilityMetricsPreviewPostParameters,
              OperationError<PreviewAdminObservabilityMetricsPreviewPostError>,
              TContext
            >
      ):
        | Mutation<
            PreviewAdminObservabilityMetricsPreviewPostData,
            PreviewAdminObservabilityMetricsPreviewPostError,
            MutationVariables<
              PreviewAdminObservabilityMetricsPreviewPostBody,
              PreviewAdminObservabilityMetricsPreviewPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              PreviewAdminObservabilityMetricsPreviewPostBody,
              PreviewAdminObservabilityMetricsPreviewPostData,
              PreviewAdminObservabilityMetricsPreviewPostParameters,
              OperationError<PreviewAdminObservabilityMetricsPreviewPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              PreviewAdminObservabilityMetricsPreviewPostSchema,
              PreviewAdminObservabilityMetricsPreviewPostBody,
              PreviewAdminObservabilityMetricsPreviewPostData,
              PreviewAdminObservabilityMetricsPreviewPostParameters,
              OperationError<PreviewAdminObservabilityMetricsPreviewPostError>,
              TContext
            >
      ): Array<
        Mutation<
          PreviewAdminObservabilityMetricsPreviewPostData,
          PreviewAdminObservabilityMetricsPreviewPostError,
          MutationVariables<
            PreviewAdminObservabilityMetricsPreviewPostBody,
            PreviewAdminObservabilityMetricsPreviewPostParameters
          >,
          TContext
        >
      >;
    };
    schema: PreviewAdminObservabilityMetricsPreviewPostSchema;
    types: {
      parameters: PreviewAdminObservabilityMetricsPreviewPostParameters;
      data: PreviewAdminObservabilityMetricsPreviewPostData;
      error: PreviewAdminObservabilityMetricsPreviewPostError;
      body: PreviewAdminObservabilityMetricsPreviewPostBody;
    };
  };
  /** @summary List Tracked Offices */
  listTrackedOfficesAdminObservabilityTrackedOfficesGet: {
    /** @summary List Tracked Offices */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters,
            TMeta,
            TSignal
          >
        | (QueryFnOptionsByParameters<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters,
            TMeta,
            TSignal
          > | void),
      client?: (
        schema: ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
        options: {
          parameters: ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
          ListTrackedOfficesAdminObservabilityTrackedOfficesGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetError
      >
    >;
    /** @summary List Tracked Offices */
    getQueryKey(
      parameters: DeepReadonly<ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters> | void
    ): ServiceOperationQueryKey<
      ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
      ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Tracked Offices
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.metricsObservabilityService.listTrackedOfficesAdminObservabilityTrackedOfficesGet.useQuery()
     * ```
     */
    useQuery<TData = ListTrackedOfficesAdminObservabilityTrackedOfficesGetData>(
      parameters:
        | ServiceOperationQueryKey<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters
          >
        | (DeepReadonly<ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
          ListTrackedOfficesAdminObservabilityTrackedOfficesGetError,
          TData,
          ServiceOperationQueryKey<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<ListTrackedOfficesAdminObservabilityTrackedOfficesGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Tracked Offices
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.metricsObservabilityService.listTrackedOfficesAdminObservabilityTrackedOfficesGet.useQuery()
     * ```
     */
    useQuery<TData = ListTrackedOfficesAdminObservabilityTrackedOfficesGetData>(
      parameters:
        | ServiceOperationQueryKey<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters
          >
        | (DeepReadonly<ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
          ListTrackedOfficesAdminObservabilityTrackedOfficesGetError,
          TData,
          ServiceOperationQueryKey<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<ListTrackedOfficesAdminObservabilityTrackedOfficesGetError>>;
    /** @summary List Tracked Offices */
    getInfiniteQueryKey(
      parameters: DeepReadonly<ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<
      ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
      ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Tracked Offices
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.metricsObservabilityService.listTrackedOfficesAdminObservabilityTrackedOfficesGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters,
      TQueryFnData = ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
      TData = OperationInfiniteData<TQueryFnData, ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters
          >
        | (DeepReadonly<ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListTrackedOfficesAdminObservabilityTrackedOfficesGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<ListTrackedOfficesAdminObservabilityTrackedOfficesGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Tracked Offices
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.metricsObservabilityService.listTrackedOfficesAdminObservabilityTrackedOfficesGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters,
      TQueryFnData = ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
      TData = OperationInfiniteData<TQueryFnData, ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters
          >
        | (DeepReadonly<ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListTrackedOfficesAdminObservabilityTrackedOfficesGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<ListTrackedOfficesAdminObservabilityTrackedOfficesGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary List Tracked Offices
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const listTrackedOfficesAdminObservabilityTrackedOfficesGetTotal = qraft.metricsObservabilityService.listTrackedOfficesAdminObservabilityTrackedOfficesGet.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
            TInfinite,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetError
          >
        | QueryFiltersByQueryKey<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
            TInfinite,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary List Tracked Offices
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const listTrackedOfficesAdminObservabilityTrackedOfficesGetResults = qraft.metricsObservabilityService.listTrackedOfficesAdminObservabilityTrackedOfficesGet.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listTrackedOfficesAdminObservabilityTrackedOfficesGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const listTrackedOfficesAdminObservabilityTrackedOfficesGetCombinedResults = qraft.metricsObservabilityService.listTrackedOfficesAdminObservabilityTrackedOfficesGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listTrackedOfficesAdminObservabilityTrackedOfficesGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
          ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters,
          ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
          ListTrackedOfficesAdminObservabilityTrackedOfficesGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
          ListTrackedOfficesAdminObservabilityTrackedOfficesGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary List Tracked Offices
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.metricsObservabilityService.listTrackedOfficesAdminObservabilityTrackedOfficesGet.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = ListTrackedOfficesAdminObservabilityTrackedOfficesGetData>(
      parameters:
        | ServiceOperationQueryKey<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters
          >
        | (DeepReadonly<ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
          ListTrackedOfficesAdminObservabilityTrackedOfficesGetError,
          TData,
          ServiceOperationQueryKey<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<ListTrackedOfficesAdminObservabilityTrackedOfficesGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary List Tracked Offices
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.metricsObservabilityService.listTrackedOfficesAdminObservabilityTrackedOfficesGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters,
      TData = ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters
          >
        | (DeepReadonly<ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
          ListTrackedOfficesAdminObservabilityTrackedOfficesGetError,
          OperationInfiniteData<TData, ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters>,
          ServiceOperationInfiniteQueryKey<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters>,
      OperationError<ListTrackedOfficesAdminObservabilityTrackedOfficesGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary List Tracked Offices
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const listTrackedOfficesAdminObservabilityTrackedOfficesGetData = qraft.metricsObservabilityService.listTrackedOfficesAdminObservabilityTrackedOfficesGet.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listTrackedOfficesAdminObservabilityTrackedOfficesGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const listTrackedOfficesAdminObservabilityTrackedOfficesGetCombinedData = qraft.metricsObservabilityService.listTrackedOfficesAdminObservabilityTrackedOfficesGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listTrackedOfficesAdminObservabilityTrackedOfficesGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
          ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters,
          ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
          ListTrackedOfficesAdminObservabilityTrackedOfficesGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
          ListTrackedOfficesAdminObservabilityTrackedOfficesGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
              ListTrackedOfficesAdminObservabilityTrackedOfficesGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary List Tracked Offices */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters,
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetError
      > | void
    ): Promise<ListTrackedOfficesAdminObservabilityTrackedOfficesGetData>;
    /** @summary List Tracked Offices */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters,
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetError
      > | void
    ): Promise<void>;
    /** @summary List Tracked Offices */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters,
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetError
      > | void
    ): Promise<ListTrackedOfficesAdminObservabilityTrackedOfficesGetData>;
    /** @summary List Tracked Offices */
    fetchInfiniteQuery<TPageParam extends ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters,
        DeepReadonly<TPageParam>,
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetError
      > | void
    ): Promise<
      OperationInfiniteData<
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters
      >
    >;
    /** @summary List Tracked Offices */
    prefetchInfiniteQuery<TPageParam extends ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters,
        DeepReadonly<TPageParam>,
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetError
      > | void
    ): Promise<void>;
    /** @summary List Tracked Offices */
    ensureInfiniteQueryData<TPageParam extends ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters,
        DeepReadonly<TPageParam>,
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetError
      > | void
    ): Promise<
      OperationInfiniteData<
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters
      >
    >;
    /** @summary List Tracked Offices */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters
          >
        | (DeepReadonly<ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters> | void)
    ): ListTrackedOfficesAdminObservabilityTrackedOfficesGetData | undefined;
    /** @summary List Tracked Offices */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters
          >
        | (DeepReadonly<ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters> | void)
    ):
      | OperationInfiniteData<
          ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
          ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters
        >
      | undefined;
    /** @summary List Tracked Offices */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
            TInfinite,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetError
          >
        | QueryFiltersByQueryKey<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
            TInfinite,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
              ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
                    ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
              ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters
            >,
            data: ListTrackedOfficesAdminObservabilityTrackedOfficesGetData | undefined,
          ]
        >;
    /** @summary List Tracked Offices */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters
          >
        | (DeepReadonly<ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters> | void)
    ):
      | QueryState<
          ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
          ListTrackedOfficesAdminObservabilityTrackedOfficesGetError
        >
      | undefined;
    /** @summary List Tracked Offices */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters>
        | ServiceOperationInfiniteQueryKey<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters
          >
        | void
    ):
      | QueryState<
          OperationInfiniteData<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters
          >,
          ListTrackedOfficesAdminObservabilityTrackedOfficesGetError
        >
      | undefined;
    /** @summary List Tracked Offices */
    setQueryData(
      parameters:
        | (DeepReadonly<ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters> | undefined)
        | ServiceOperationQueryKey<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters
          >,
      updater: Updater<
        NoInfer<ListTrackedOfficesAdminObservabilityTrackedOfficesGetData> | undefined,
        NoInfer<DeepReadonly<ListTrackedOfficesAdminObservabilityTrackedOfficesGetData>> | undefined
      >,
      options?: SetDataOptions
    ): ListTrackedOfficesAdminObservabilityTrackedOfficesGetData | undefined;
    /** @summary List Tracked Offices */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
              ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
                ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
          ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters
        >
      | undefined;
    /** @summary List Tracked Offices */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
            TInfinite,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetError
          >
        | QueryFiltersByQueryKey<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
            TInfinite,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetError
          >,
      updater: Updater<
        NoInfer<ListTrackedOfficesAdminObservabilityTrackedOfficesGetData> | undefined,
        NoInfer<ListTrackedOfficesAdminObservabilityTrackedOfficesGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<ListTrackedOfficesAdminObservabilityTrackedOfficesGetData | undefined>;
    /** @summary List Tracked Offices */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
        TInfinite,
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters,
        ListTrackedOfficesAdminObservabilityTrackedOfficesGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary List Tracked Offices */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
            TInfinite,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetError
          >
        | QueryFiltersByQueryKey<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
            TInfinite,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary List Tracked Offices */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
            TInfinite,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetError
          >
        | QueryFiltersByQueryKey<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
            TInfinite,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary List Tracked Offices */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
            TInfinite,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetError
          >
        | QueryFiltersByQueryKey<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
            TInfinite,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetError
          >
    ): void;
    /** @summary List Tracked Offices */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
            TInfinite,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetError
          >
        | QueryFiltersByQueryKey<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
            TInfinite,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary List Tracked Offices */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
            TInfinite,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetError
          >
        | QueryFiltersByQueryKey<
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetData,
            TInfinite,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters,
            ListTrackedOfficesAdminObservabilityTrackedOfficesGetError
          >
    ): number;
    schema: ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema;
    types: {
      parameters: ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters;
      data: ListTrackedOfficesAdminObservabilityTrackedOfficesGetData;
      error: ListTrackedOfficesAdminObservabilityTrackedOfficesGetError;
    };
  };
  /** @summary Set Tracked Office */
  setTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPut: {
    /** @summary Set Tracked Office */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutBody,
        SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutSchema,
        options: ServiceOperationMutationFnOptions<
          SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutBody,
          SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutData,
          SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutError
        >
      >
    ): Promise<
      RequestFnResponse<
        SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutData,
        SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutError
      >
    >;
    /** @summary Set Tracked Office */
    getMutationKey(
      parameters: DeepReadonly<SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutParameters> | void
    ): ServiceOperationMutationKey<
      SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutSchema,
      SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Set Tracked Office
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.metricsObservabilityService.setTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPut.useMutation({
     *     path: {
     *         office_id: officeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.metricsObservabilityService.setTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPut.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         office_id: officeId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutBody, TContext = unknown>(
      parameters: DeepReadonly<SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutParameters>,
      options?: ServiceOperationUseMutationOptions<
        SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutSchema,
        SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutData,
        SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutParameters,
        TVariables,
        OperationError<SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutError>,
        TContext
      >
    ): UseMutationResult<
      SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutData,
      OperationError<SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Set Tracked Office
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.metricsObservabilityService.setTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPut.useMutation({
     *     path: {
     *         office_id: officeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.metricsObservabilityService.setTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPut.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         office_id: officeId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutBody,
        SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutSchema,
        SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutData,
        SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutParameters,
        TVariables,
        OperationError<SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutError>,
        TContext
      >
    ): UseMutationResult<
      SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutData,
      OperationError<SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Set Tracked Office
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const setTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutTotal = qraft.metricsObservabilityService.setTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPut.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const setTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutTotal = qraft.metricsObservabilityService.setTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPut.useIsMutating({
     *     parameters: {
     *         path: {
     *             office_id: officeId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutBody,
            SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutData,
            SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutParameters,
            OperationError<SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutSchema,
            SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutBody,
            SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutData,
            SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutParameters,
            OperationError<SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Set Tracked Office
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const setTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutPendingMutationVariables = qraft.metricsObservabilityService.setTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPut.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const setTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutMutationData = qraft.metricsObservabilityService.setTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPut.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 office_id: officeId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutData,
        OperationError<SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutError>,
        MutationVariables<
          SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutBody,
          SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutBody,
            SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutData,
            SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutParameters,
            OperationError<SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutSchema,
            SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutBody,
            SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutData,
            SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutParameters,
            OperationError<SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutData,
          OperationError<SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutError>,
          MutationVariables<
            SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutBody,
            SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Set Tracked Office */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutBody,
            SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutData,
            SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutParameters,
            OperationError<SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutSchema,
            SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutBody,
            SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutData,
            SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutParameters,
            OperationError<SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Set Tracked Office
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.metricsObservabilityService.setTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPut.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             office_id: officeId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.metricsObservabilityService.setTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPut.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutBody,
              SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutData,
              SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutParameters,
              OperationError<SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutSchema,
              SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutBody,
              SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutData,
              SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutParameters,
              OperationError<SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutError>,
              TContext
            >
      ):
        | Mutation<
            SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutData,
            SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutError,
            MutationVariables<
              SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutBody,
              SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutBody,
              SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutData,
              SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutParameters,
              OperationError<SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutSchema,
              SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutBody,
              SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutData,
              SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutParameters,
              OperationError<SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutError>,
              TContext
            >
      ): Array<
        Mutation<
          SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutData,
          SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutError,
          MutationVariables<
            SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutBody,
            SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutParameters
          >,
          TContext
        >
      >;
    };
    schema: SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutSchema;
    types: {
      parameters: SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutParameters;
      data: SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutData;
      error: SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutError;
      body: SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutBody;
    };
  };
}
/** @summary List Definitions */
export const listDefinitionsAdminObservabilityDefinitionsGet = {
  schema: {
    method: 'get',
    url: '/admin/observability/definitions',
    security: ['HTTPBearer'],
  },
} as {
  schema: ListDefinitionsAdminObservabilityDefinitionsGetSchema;
  [QraftServiceOperationsToken]: MetricsObservabilityService['listDefinitionsAdminObservabilityDefinitionsGet'];
};
/** @summary Create Definition */
export const createDefinitionAdminObservabilityConfigDefinitionsPost = {
  schema: {
    method: 'post',
    url: '/admin/observability/config/definitions',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateDefinitionAdminObservabilityConfigDefinitionsPostSchema;
  [QraftServiceOperationsToken]: MetricsObservabilityService['createDefinitionAdminObservabilityConfigDefinitionsPost'];
};
/** @summary Update Definition */
export const updateDefinitionAdminObservabilityConfigDefinitionsKeyPut = {
  schema: {
    method: 'put',
    url: '/admin/observability/config/definitions/{key}',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutSchema;
  [QraftServiceOperationsToken]: MetricsObservabilityService['updateDefinitionAdminObservabilityConfigDefinitionsKeyPut'];
};
/** @summary Get Values */
export const getValuesAdminObservabilityValuesGet = {
  schema: {
    method: 'get',
    url: '/admin/observability/values',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetValuesAdminObservabilityValuesGetSchema;
  [QraftServiceOperationsToken]: MetricsObservabilityService['getValuesAdminObservabilityValuesGet'];
};
/**
 * @summary Get Values Baseline
 * @description The alert baseline line for the window — the SAME trailing-active-median the Slack alerts use
 * (N5 / ADR-047). Mirrors `/values` params; the per-office series' value at the alert period equals
 * the alert's stored `baseline_value` by construction. Pooled is a new, informational artifact.
 */
export const getValuesBaselineAdminObservabilityValuesBaselineGet = {
  schema: {
    method: 'get',
    url: '/admin/observability/values/baseline',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetValuesBaselineAdminObservabilityValuesBaselineGetSchema;
  [QraftServiceOperationsToken]: MetricsObservabilityService['getValuesBaselineAdminObservabilityValuesBaselineGet'];
};
/** @summary Compare Values */
export const compareValuesAdminObservabilityValuesCompareGet = {
  schema: {
    method: 'get',
    url: '/admin/observability/values/compare',
    security: ['HTTPBearer'],
  },
} as {
  schema: CompareValuesAdminObservabilityValuesCompareGetSchema;
  [QraftServiceOperationsToken]: MetricsObservabilityService['compareValuesAdminObservabilityValuesCompareGet'];
};
/** @summary List Runs */
export const listRunsAdminObservabilityRunsGet = {
  schema: {
    method: 'get',
    url: '/admin/observability/runs',
    security: ['HTTPBearer'],
  },
} as {
  schema: ListRunsAdminObservabilityRunsGetSchema;
  [QraftServiceOperationsToken]: MetricsObservabilityService['listRunsAdminObservabilityRunsGet'];
};
/** @summary Get Run */
export const getRunAdminObservabilityRunsRunIdGet = {
  schema: {
    method: 'get',
    url: '/admin/observability/runs/{run_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetRunAdminObservabilityRunsRunIdGetSchema;
  [QraftServiceOperationsToken]: MetricsObservabilityService['getRunAdminObservabilityRunsRunIdGet'];
};
/** @summary List Office Settings Versions */
export const listOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGet = {
  schema: {
    method: 'get',
    url: '/admin/observability/office_settings_versions',
    security: ['HTTPBearer'],
  },
} as {
  schema: ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema;
  [QraftServiceOperationsToken]: MetricsObservabilityService['listOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGet'];
};
/** @summary Recalculate */
export const recalculateAdminObservabilityConfigRecalculatePost = {
  schema: {
    method: 'post',
    url: '/admin/observability/config/recalculate',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: RecalculateAdminObservabilityConfigRecalculatePostSchema;
  [QraftServiceOperationsToken]: MetricsObservabilityService['recalculateAdminObservabilityConfigRecalculatePost'];
};
/** @summary Preview */
export const previewAdminObservabilityMetricsPreviewPost = {
  schema: {
    method: 'post',
    url: '/admin/observability/metrics/preview',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: PreviewAdminObservabilityMetricsPreviewPostSchema;
  [QraftServiceOperationsToken]: MetricsObservabilityService['previewAdminObservabilityMetricsPreviewPost'];
};
/** @summary List Tracked Offices */
export const listTrackedOfficesAdminObservabilityTrackedOfficesGet = {
  schema: {
    method: 'get',
    url: '/admin/observability/tracked_offices',
    security: ['HTTPBearer'],
  },
} as {
  schema: ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema;
  [QraftServiceOperationsToken]: MetricsObservabilityService['listTrackedOfficesAdminObservabilityTrackedOfficesGet'];
};
/** @summary Set Tracked Office */
export const setTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPut = {
  schema: {
    method: 'put',
    url: '/admin/observability/tracked_offices/{office_id}',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutSchema;
  [QraftServiceOperationsToken]: MetricsObservabilityService['setTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPut'];
};
export const metricsObservabilityService = {
  listDefinitionsAdminObservabilityDefinitionsGet,
  createDefinitionAdminObservabilityConfigDefinitionsPost,
  updateDefinitionAdminObservabilityConfigDefinitionsKeyPut,
  getValuesAdminObservabilityValuesGet,
  getValuesBaselineAdminObservabilityValuesBaselineGet,
  compareValuesAdminObservabilityValuesCompareGet,
  listRunsAdminObservabilityRunsGet,
  getRunAdminObservabilityRunsRunIdGet,
  listOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGet,
  recalculateAdminObservabilityConfigRecalculatePost,
  previewAdminObservabilityMetricsPreviewPost,
  listTrackedOfficesAdminObservabilityTrackedOfficesGet,
  setTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPut,
} as const;
type ListDefinitionsAdminObservabilityDefinitionsGetSchema = {
  method: 'get';
  url: '/admin/observability/definitions';
  security: ['HTTPBearer'];
};
type ListDefinitionsAdminObservabilityDefinitionsGetParameters = undefined;
type ListDefinitionsAdminObservabilityDefinitionsGetData =
  paths['/admin/observability/definitions']['get']['responses']['200']['content']['application/json'];
type ListDefinitionsAdminObservabilityDefinitionsGetError = unknown;
type CreateDefinitionAdminObservabilityConfigDefinitionsPostSchema = {
  method: 'post';
  url: '/admin/observability/config/definitions';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateDefinitionAdminObservabilityConfigDefinitionsPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateDefinitionAdminObservabilityConfigDefinitionsPostData =
  paths['/admin/observability/config/definitions']['post']['responses']['200']['content']['application/json'];
type CreateDefinitionAdminObservabilityConfigDefinitionsPostError =
  paths['/admin/observability/config/definitions']['post']['responses']['422']['content']['application/json'];
type CreateDefinitionAdminObservabilityConfigDefinitionsPostBody =
  paths['/admin/observability/config/definitions']['post']['requestBody']['content']['application/json'];
type UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutSchema = {
  method: 'put';
  url: '/admin/observability/config/definitions/{key}';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutParameters =
  paths['/admin/observability/config/definitions/{key}']['put']['parameters'];
type UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutData =
  paths['/admin/observability/config/definitions/{key}']['put']['responses']['200']['content']['application/json'];
type UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutError =
  paths['/admin/observability/config/definitions/{key}']['put']['responses']['422']['content']['application/json'];
type UpdateDefinitionAdminObservabilityConfigDefinitionsKeyPutBody =
  paths['/admin/observability/config/definitions/{key}']['put']['requestBody']['content']['application/json'];
type GetValuesAdminObservabilityValuesGetSchema = {
  method: 'get';
  url: '/admin/observability/values';
  security: ['HTTPBearer'];
};
type GetValuesAdminObservabilityValuesGetParameters = paths['/admin/observability/values']['get']['parameters'];
type GetValuesAdminObservabilityValuesGetData =
  paths['/admin/observability/values']['get']['responses']['200']['content']['application/json'];
type GetValuesAdminObservabilityValuesGetError =
  paths['/admin/observability/values']['get']['responses']['422']['content']['application/json'];
type GetValuesBaselineAdminObservabilityValuesBaselineGetSchema = {
  method: 'get';
  url: '/admin/observability/values/baseline';
  security: ['HTTPBearer'];
};
type GetValuesBaselineAdminObservabilityValuesBaselineGetParameters =
  paths['/admin/observability/values/baseline']['get']['parameters'];
type GetValuesBaselineAdminObservabilityValuesBaselineGetData =
  paths['/admin/observability/values/baseline']['get']['responses']['200']['content']['application/json'];
type GetValuesBaselineAdminObservabilityValuesBaselineGetError =
  paths['/admin/observability/values/baseline']['get']['responses']['422']['content']['application/json'];
type CompareValuesAdminObservabilityValuesCompareGetSchema = {
  method: 'get';
  url: '/admin/observability/values/compare';
  security: ['HTTPBearer'];
};
type CompareValuesAdminObservabilityValuesCompareGetParameters =
  paths['/admin/observability/values/compare']['get']['parameters'];
type CompareValuesAdminObservabilityValuesCompareGetData =
  paths['/admin/observability/values/compare']['get']['responses']['200']['content']['application/json'];
type CompareValuesAdminObservabilityValuesCompareGetError =
  paths['/admin/observability/values/compare']['get']['responses']['422']['content']['application/json'];
type ListRunsAdminObservabilityRunsGetSchema = {
  method: 'get';
  url: '/admin/observability/runs';
  security: ['HTTPBearer'];
};
type ListRunsAdminObservabilityRunsGetParameters = paths['/admin/observability/runs']['get']['parameters'];
type ListRunsAdminObservabilityRunsGetData =
  paths['/admin/observability/runs']['get']['responses']['200']['content']['application/json'];
type ListRunsAdminObservabilityRunsGetError =
  paths['/admin/observability/runs']['get']['responses']['422']['content']['application/json'];
type GetRunAdminObservabilityRunsRunIdGetSchema = {
  method: 'get';
  url: '/admin/observability/runs/{run_id}';
  security: ['HTTPBearer'];
};
type GetRunAdminObservabilityRunsRunIdGetParameters = paths['/admin/observability/runs/{run_id}']['get']['parameters'];
type GetRunAdminObservabilityRunsRunIdGetData =
  paths['/admin/observability/runs/{run_id}']['get']['responses']['200']['content']['application/json'];
type GetRunAdminObservabilityRunsRunIdGetError =
  paths['/admin/observability/runs/{run_id}']['get']['responses']['422']['content']['application/json'];
type ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetSchema = {
  method: 'get';
  url: '/admin/observability/office_settings_versions';
  security: ['HTTPBearer'];
};
type ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetParameters =
  paths['/admin/observability/office_settings_versions']['get']['parameters'];
type ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetData =
  paths['/admin/observability/office_settings_versions']['get']['responses']['200']['content']['application/json'];
type ListOfficeSettingsVersionsAdminObservabilityOfficeSettingsVersionsGetError =
  paths['/admin/observability/office_settings_versions']['get']['responses']['422']['content']['application/json'];
type RecalculateAdminObservabilityConfigRecalculatePostSchema = {
  method: 'post';
  url: '/admin/observability/config/recalculate';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type RecalculateAdminObservabilityConfigRecalculatePostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type RecalculateAdminObservabilityConfigRecalculatePostData =
  paths['/admin/observability/config/recalculate']['post']['responses']['200']['content']['application/json'];
type RecalculateAdminObservabilityConfigRecalculatePostError =
  paths['/admin/observability/config/recalculate']['post']['responses']['422']['content']['application/json'];
type RecalculateAdminObservabilityConfigRecalculatePostBody =
  paths['/admin/observability/config/recalculate']['post']['requestBody']['content']['application/json'];
type PreviewAdminObservabilityMetricsPreviewPostSchema = {
  method: 'post';
  url: '/admin/observability/metrics/preview';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type PreviewAdminObservabilityMetricsPreviewPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type PreviewAdminObservabilityMetricsPreviewPostData =
  paths['/admin/observability/metrics/preview']['post']['responses']['200']['content']['application/json'];
type PreviewAdminObservabilityMetricsPreviewPostError =
  paths['/admin/observability/metrics/preview']['post']['responses']['422']['content']['application/json'];
type PreviewAdminObservabilityMetricsPreviewPostBody =
  paths['/admin/observability/metrics/preview']['post']['requestBody']['content']['application/json'];
type ListTrackedOfficesAdminObservabilityTrackedOfficesGetSchema = {
  method: 'get';
  url: '/admin/observability/tracked_offices';
  security: ['HTTPBearer'];
};
type ListTrackedOfficesAdminObservabilityTrackedOfficesGetParameters = undefined;
type ListTrackedOfficesAdminObservabilityTrackedOfficesGetData =
  paths['/admin/observability/tracked_offices']['get']['responses']['200']['content']['application/json'];
type ListTrackedOfficesAdminObservabilityTrackedOfficesGetError = unknown;
type SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutSchema = {
  method: 'put';
  url: '/admin/observability/tracked_offices/{office_id}';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutParameters =
  paths['/admin/observability/tracked_offices/{office_id}']['put']['parameters'];
type SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutData =
  paths['/admin/observability/tracked_offices/{office_id}']['put']['responses']['200']['content']['application/json'];
type SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutError =
  paths['/admin/observability/tracked_offices/{office_id}']['put']['responses']['422']['content']['application/json'];
type SetTrackedOfficeAdminObservabilityTrackedOfficesOfficeIdPutBody =
  paths['/admin/observability/tracked_offices/{office_id}']['put']['requestBody']['content']['application/json'];
